(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "lodash", "prop-types", "@fiverr/i18n/singleton", "@fiverr/gofor", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["SellerCard"] = factory(require("@fiverr/globals"), require("react"), require("lodash"), require("prop-types"), require("@fiverr/i18n/singleton"), require("@fiverr/gofor"), require("react-dom"));
	else
		root["SellerCard"] = factory(root["@fiverr/globals"], root["React"], root["_"], root["PropTypes"], root["i18n"], root["goforFactory"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_PbPb__, __WEBPACK_EXTERNAL_MODULE_T9WB__, __WEBPACK_EXTERNAL_MODULE_h4G9__, __WEBPACK_EXTERNAL_MODULE_jPm4__, __WEBPACK_EXTERNAL_MODULE_wLXD__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://npm-assets.fiverrcdn.com/assets/@fiverr/seller_card/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "lVK7");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/cOS":
/***/ (function(module, exports) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

function getDefaultWhiteList () {
  // 白名单值说明：
  // true: 允许该属性
  // Function: function (val) { } 返回true表示允许该属性，其他值均表示不允许
  // RegExp: regexp.test(val) 返回true表示允许该属性，其他值均表示不允许
  // 除上面列出的值外均表示不允许
  var whiteList = {};

  whiteList['align-content'] = false; // default: auto
  whiteList['align-items'] = false; // default: auto
  whiteList['align-self'] = false; // default: auto
  whiteList['alignment-adjust'] = false; // default: auto
  whiteList['alignment-baseline'] = false; // default: baseline
  whiteList['all'] = false; // default: depending on individual properties
  whiteList['anchor-point'] = false; // default: none
  whiteList['animation'] = false; // default: depending on individual properties
  whiteList['animation-delay'] = false; // default: 0
  whiteList['animation-direction'] = false; // default: normal
  whiteList['animation-duration'] = false; // default: 0
  whiteList['animation-fill-mode'] = false; // default: none
  whiteList['animation-iteration-count'] = false; // default: 1
  whiteList['animation-name'] = false; // default: none
  whiteList['animation-play-state'] = false; // default: running
  whiteList['animation-timing-function'] = false; // default: ease
  whiteList['azimuth'] = false; // default: center
  whiteList['backface-visibility'] = false; // default: visible
  whiteList['background'] = true; // default: depending on individual properties
  whiteList['background-attachment'] = true; // default: scroll
  whiteList['background-clip'] = true; // default: border-box
  whiteList['background-color'] = true; // default: transparent
  whiteList['background-image'] = true; // default: none
  whiteList['background-origin'] = true; // default: padding-box
  whiteList['background-position'] = true; // default: 0% 0%
  whiteList['background-repeat'] = true; // default: repeat
  whiteList['background-size'] = true; // default: auto
  whiteList['baseline-shift'] = false; // default: baseline
  whiteList['binding'] = false; // default: none
  whiteList['bleed'] = false; // default: 6pt
  whiteList['bookmark-label'] = false; // default: content()
  whiteList['bookmark-level'] = false; // default: none
  whiteList['bookmark-state'] = false; // default: open
  whiteList['border'] = true; // default: depending on individual properties
  whiteList['border-bottom'] = true; // default: depending on individual properties
  whiteList['border-bottom-color'] = true; // default: current color
  whiteList['border-bottom-left-radius'] = true; // default: 0
  whiteList['border-bottom-right-radius'] = true; // default: 0
  whiteList['border-bottom-style'] = true; // default: none
  whiteList['border-bottom-width'] = true; // default: medium
  whiteList['border-collapse'] = true; // default: separate
  whiteList['border-color'] = true; // default: depending on individual properties
  whiteList['border-image'] = true; // default: none
  whiteList['border-image-outset'] = true; // default: 0
  whiteList['border-image-repeat'] = true; // default: stretch
  whiteList['border-image-slice'] = true; // default: 100%
  whiteList['border-image-source'] = true; // default: none
  whiteList['border-image-width'] = true; // default: 1
  whiteList['border-left'] = true; // default: depending on individual properties
  whiteList['border-left-color'] = true; // default: current color
  whiteList['border-left-style'] = true; // default: none
  whiteList['border-left-width'] = true; // default: medium
  whiteList['border-radius'] = true; // default: 0
  whiteList['border-right'] = true; // default: depending on individual properties
  whiteList['border-right-color'] = true; // default: current color
  whiteList['border-right-style'] = true; // default: none
  whiteList['border-right-width'] = true; // default: medium
  whiteList['border-spacing'] = true; // default: 0
  whiteList['border-style'] = true; // default: depending on individual properties
  whiteList['border-top'] = true; // default: depending on individual properties
  whiteList['border-top-color'] = true; // default: current color
  whiteList['border-top-left-radius'] = true; // default: 0
  whiteList['border-top-right-radius'] = true; // default: 0
  whiteList['border-top-style'] = true; // default: none
  whiteList['border-top-width'] = true; // default: medium
  whiteList['border-width'] = true; // default: depending on individual properties
  whiteList['bottom'] = false; // default: auto
  whiteList['box-decoration-break'] = true; // default: slice
  whiteList['box-shadow'] = true; // default: none
  whiteList['box-sizing'] = true; // default: content-box
  whiteList['box-snap'] = true; // default: none
  whiteList['box-suppress'] = true; // default: show
  whiteList['break-after'] = true; // default: auto
  whiteList['break-before'] = true; // default: auto
  whiteList['break-inside'] = true; // default: auto
  whiteList['caption-side'] = false; // default: top
  whiteList['chains'] = false; // default: none
  whiteList['clear'] = true; // default: none
  whiteList['clip'] = false; // default: auto
  whiteList['clip-path'] = false; // default: none
  whiteList['clip-rule'] = false; // default: nonzero
  whiteList['color'] = true; // default: implementation dependent
  whiteList['color-interpolation-filters'] = true; // default: auto
  whiteList['column-count'] = false; // default: auto
  whiteList['column-fill'] = false; // default: balance
  whiteList['column-gap'] = false; // default: normal
  whiteList['column-rule'] = false; // default: depending on individual properties
  whiteList['column-rule-color'] = false; // default: current color
  whiteList['column-rule-style'] = false; // default: medium
  whiteList['column-rule-width'] = false; // default: medium
  whiteList['column-span'] = false; // default: none
  whiteList['column-width'] = false; // default: auto
  whiteList['columns'] = false; // default: depending on individual properties
  whiteList['contain'] = false; // default: none
  whiteList['content'] = false; // default: normal
  whiteList['counter-increment'] = false; // default: none
  whiteList['counter-reset'] = false; // default: none
  whiteList['counter-set'] = false; // default: none
  whiteList['crop'] = false; // default: auto
  whiteList['cue'] = false; // default: depending on individual properties
  whiteList['cue-after'] = false; // default: none
  whiteList['cue-before'] = false; // default: none
  whiteList['cursor'] = false; // default: auto
  whiteList['direction'] = false; // default: ltr
  whiteList['display'] = true; // default: depending on individual properties
  whiteList['display-inside'] = true; // default: auto
  whiteList['display-list'] = true; // default: none
  whiteList['display-outside'] = true; // default: inline-level
  whiteList['dominant-baseline'] = false; // default: auto
  whiteList['elevation'] = false; // default: level
  whiteList['empty-cells'] = false; // default: show
  whiteList['filter'] = false; // default: none
  whiteList['flex'] = false; // default: depending on individual properties
  whiteList['flex-basis'] = false; // default: auto
  whiteList['flex-direction'] = false; // default: row
  whiteList['flex-flow'] = false; // default: depending on individual properties
  whiteList['flex-grow'] = false; // default: 0
  whiteList['flex-shrink'] = false; // default: 1
  whiteList['flex-wrap'] = false; // default: nowrap
  whiteList['float'] = false; // default: none
  whiteList['float-offset'] = false; // default: 0 0
  whiteList['flood-color'] = false; // default: black
  whiteList['flood-opacity'] = false; // default: 1
  whiteList['flow-from'] = false; // default: none
  whiteList['flow-into'] = false; // default: none
  whiteList['font'] = true; // default: depending on individual properties
  whiteList['font-family'] = true; // default: implementation dependent
  whiteList['font-feature-settings'] = true; // default: normal
  whiteList['font-kerning'] = true; // default: auto
  whiteList['font-language-override'] = true; // default: normal
  whiteList['font-size'] = true; // default: medium
  whiteList['font-size-adjust'] = true; // default: none
  whiteList['font-stretch'] = true; // default: normal
  whiteList['font-style'] = true; // default: normal
  whiteList['font-synthesis'] = true; // default: weight style
  whiteList['font-variant'] = true; // default: normal
  whiteList['font-variant-alternates'] = true; // default: normal
  whiteList['font-variant-caps'] = true; // default: normal
  whiteList['font-variant-east-asian'] = true; // default: normal
  whiteList['font-variant-ligatures'] = true; // default: normal
  whiteList['font-variant-numeric'] = true; // default: normal
  whiteList['font-variant-position'] = true; // default: normal
  whiteList['font-weight'] = true; // default: normal
  whiteList['grid'] = false; // default: depending on individual properties
  whiteList['grid-area'] = false; // default: depending on individual properties
  whiteList['grid-auto-columns'] = false; // default: auto
  whiteList['grid-auto-flow'] = false; // default: none
  whiteList['grid-auto-rows'] = false; // default: auto
  whiteList['grid-column'] = false; // default: depending on individual properties
  whiteList['grid-column-end'] = false; // default: auto
  whiteList['grid-column-start'] = false; // default: auto
  whiteList['grid-row'] = false; // default: depending on individual properties
  whiteList['grid-row-end'] = false; // default: auto
  whiteList['grid-row-start'] = false; // default: auto
  whiteList['grid-template'] = false; // default: depending on individual properties
  whiteList['grid-template-areas'] = false; // default: none
  whiteList['grid-template-columns'] = false; // default: none
  whiteList['grid-template-rows'] = false; // default: none
  whiteList['hanging-punctuation'] = false; // default: none
  whiteList['height'] = true; // default: auto
  whiteList['hyphens'] = false; // default: manual
  whiteList['icon'] = false; // default: auto
  whiteList['image-orientation'] = false; // default: auto
  whiteList['image-resolution'] = false; // default: normal
  whiteList['ime-mode'] = false; // default: auto
  whiteList['initial-letters'] = false; // default: normal
  whiteList['inline-box-align'] = false; // default: last
  whiteList['justify-content'] = false; // default: auto
  whiteList['justify-items'] = false; // default: auto
  whiteList['justify-self'] = false; // default: auto
  whiteList['left'] = false; // default: auto
  whiteList['letter-spacing'] = true; // default: normal
  whiteList['lighting-color'] = true; // default: white
  whiteList['line-box-contain'] = false; // default: block inline replaced
  whiteList['line-break'] = false; // default: auto
  whiteList['line-grid'] = false; // default: match-parent
  whiteList['line-height'] = false; // default: normal
  whiteList['line-snap'] = false; // default: none
  whiteList['line-stacking'] = false; // default: depending on individual properties
  whiteList['line-stacking-ruby'] = false; // default: exclude-ruby
  whiteList['line-stacking-shift'] = false; // default: consider-shifts
  whiteList['line-stacking-strategy'] = false; // default: inline-line-height
  whiteList['list-style'] = true; // default: depending on individual properties
  whiteList['list-style-image'] = true; // default: none
  whiteList['list-style-position'] = true; // default: outside
  whiteList['list-style-type'] = true; // default: disc
  whiteList['margin'] = true; // default: depending on individual properties
  whiteList['margin-bottom'] = true; // default: 0
  whiteList['margin-left'] = true; // default: 0
  whiteList['margin-right'] = true; // default: 0
  whiteList['margin-top'] = true; // default: 0
  whiteList['marker-offset'] = false; // default: auto
  whiteList['marker-side'] = false; // default: list-item
  whiteList['marks'] = false; // default: none
  whiteList['mask'] = false; // default: border-box
  whiteList['mask-box'] = false; // default: see individual properties
  whiteList['mask-box-outset'] = false; // default: 0
  whiteList['mask-box-repeat'] = false; // default: stretch
  whiteList['mask-box-slice'] = false; // default: 0 fill
  whiteList['mask-box-source'] = false; // default: none
  whiteList['mask-box-width'] = false; // default: auto
  whiteList['mask-clip'] = false; // default: border-box
  whiteList['mask-image'] = false; // default: none
  whiteList['mask-origin'] = false; // default: border-box
  whiteList['mask-position'] = false; // default: center
  whiteList['mask-repeat'] = false; // default: no-repeat
  whiteList['mask-size'] = false; // default: border-box
  whiteList['mask-source-type'] = false; // default: auto
  whiteList['mask-type'] = false; // default: luminance
  whiteList['max-height'] = true; // default: none
  whiteList['max-lines'] = false; // default: none
  whiteList['max-width'] = true; // default: none
  whiteList['min-height'] = true; // default: 0
  whiteList['min-width'] = true; // default: 0
  whiteList['move-to'] = false; // default: normal
  whiteList['nav-down'] = false; // default: auto
  whiteList['nav-index'] = false; // default: auto
  whiteList['nav-left'] = false; // default: auto
  whiteList['nav-right'] = false; // default: auto
  whiteList['nav-up'] = false; // default: auto
  whiteList['object-fit'] = false; // default: fill
  whiteList['object-position'] = false; // default: 50% 50%
  whiteList['opacity'] = false; // default: 1
  whiteList['order'] = false; // default: 0
  whiteList['orphans'] = false; // default: 2
  whiteList['outline'] = false; // default: depending on individual properties
  whiteList['outline-color'] = false; // default: invert
  whiteList['outline-offset'] = false; // default: 0
  whiteList['outline-style'] = false; // default: none
  whiteList['outline-width'] = false; // default: medium
  whiteList['overflow'] = false; // default: depending on individual properties
  whiteList['overflow-wrap'] = false; // default: normal
  whiteList['overflow-x'] = false; // default: visible
  whiteList['overflow-y'] = false; // default: visible
  whiteList['padding'] = true; // default: depending on individual properties
  whiteList['padding-bottom'] = true; // default: 0
  whiteList['padding-left'] = true; // default: 0
  whiteList['padding-right'] = true; // default: 0
  whiteList['padding-top'] = true; // default: 0
  whiteList['page'] = false; // default: auto
  whiteList['page-break-after'] = false; // default: auto
  whiteList['page-break-before'] = false; // default: auto
  whiteList['page-break-inside'] = false; // default: auto
  whiteList['page-policy'] = false; // default: start
  whiteList['pause'] = false; // default: implementation dependent
  whiteList['pause-after'] = false; // default: implementation dependent
  whiteList['pause-before'] = false; // default: implementation dependent
  whiteList['perspective'] = false; // default: none
  whiteList['perspective-origin'] = false; // default: 50% 50%
  whiteList['pitch'] = false; // default: medium
  whiteList['pitch-range'] = false; // default: 50
  whiteList['play-during'] = false; // default: auto
  whiteList['position'] = false; // default: static
  whiteList['presentation-level'] = false; // default: 0
  whiteList['quotes'] = false; // default: text
  whiteList['region-fragment'] = false; // default: auto
  whiteList['resize'] = false; // default: none
  whiteList['rest'] = false; // default: depending on individual properties
  whiteList['rest-after'] = false; // default: none
  whiteList['rest-before'] = false; // default: none
  whiteList['richness'] = false; // default: 50
  whiteList['right'] = false; // default: auto
  whiteList['rotation'] = false; // default: 0
  whiteList['rotation-point'] = false; // default: 50% 50%
  whiteList['ruby-align'] = false; // default: auto
  whiteList['ruby-merge'] = false; // default: separate
  whiteList['ruby-position'] = false; // default: before
  whiteList['shape-image-threshold'] = false; // default: 0.0
  whiteList['shape-outside'] = false; // default: none
  whiteList['shape-margin'] = false; // default: 0
  whiteList['size'] = false; // default: auto
  whiteList['speak'] = false; // default: auto
  whiteList['speak-as'] = false; // default: normal
  whiteList['speak-header'] = false; // default: once
  whiteList['speak-numeral'] = false; // default: continuous
  whiteList['speak-punctuation'] = false; // default: none
  whiteList['speech-rate'] = false; // default: medium
  whiteList['stress'] = false; // default: 50
  whiteList['string-set'] = false; // default: none
  whiteList['tab-size'] = false; // default: 8
  whiteList['table-layout'] = false; // default: auto
  whiteList['text-align'] = true; // default: start
  whiteList['text-align-last'] = true; // default: auto
  whiteList['text-combine-upright'] = true; // default: none
  whiteList['text-decoration'] = true; // default: none
  whiteList['text-decoration-color'] = true; // default: currentColor
  whiteList['text-decoration-line'] = true; // default: none
  whiteList['text-decoration-skip'] = true; // default: objects
  whiteList['text-decoration-style'] = true; // default: solid
  whiteList['text-emphasis'] = true; // default: depending on individual properties
  whiteList['text-emphasis-color'] = true; // default: currentColor
  whiteList['text-emphasis-position'] = true; // default: over right
  whiteList['text-emphasis-style'] = true; // default: none
  whiteList['text-height'] = true; // default: auto
  whiteList['text-indent'] = true; // default: 0
  whiteList['text-justify'] = true; // default: auto
  whiteList['text-orientation'] = true; // default: mixed
  whiteList['text-overflow'] = true; // default: clip
  whiteList['text-shadow'] = true; // default: none
  whiteList['text-space-collapse'] = true; // default: collapse
  whiteList['text-transform'] = true; // default: none
  whiteList['text-underline-position'] = true; // default: auto
  whiteList['text-wrap'] = true; // default: normal
  whiteList['top'] = false; // default: auto
  whiteList['transform'] = false; // default: none
  whiteList['transform-origin'] = false; // default: 50% 50% 0
  whiteList['transform-style'] = false; // default: flat
  whiteList['transition'] = false; // default: depending on individual properties
  whiteList['transition-delay'] = false; // default: 0s
  whiteList['transition-duration'] = false; // default: 0s
  whiteList['transition-property'] = false; // default: all
  whiteList['transition-timing-function'] = false; // default: ease
  whiteList['unicode-bidi'] = false; // default: normal
  whiteList['vertical-align'] = false; // default: baseline
  whiteList['visibility'] = false; // default: visible
  whiteList['voice-balance'] = false; // default: center
  whiteList['voice-duration'] = false; // default: auto
  whiteList['voice-family'] = false; // default: implementation dependent
  whiteList['voice-pitch'] = false; // default: medium
  whiteList['voice-range'] = false; // default: medium
  whiteList['voice-rate'] = false; // default: normal
  whiteList['voice-stress'] = false; // default: normal
  whiteList['voice-volume'] = false; // default: medium
  whiteList['volume'] = false; // default: medium
  whiteList['white-space'] = false; // default: normal
  whiteList['widows'] = false; // default: 2
  whiteList['width'] = true; // default: auto
  whiteList['will-change'] = false; // default: auto
  whiteList['word-break'] = true; // default: normal
  whiteList['word-spacing'] = true; // default: normal
  whiteList['word-wrap'] = true; // default: normal
  whiteList['wrap-flow'] = false; // default: auto
  whiteList['wrap-through'] = false; // default: wrap
  whiteList['writing-mode'] = false; // default: horizontal-tb
  whiteList['z-index'] = false; // default: auto

  return whiteList;
}


/**
 * 匹配到白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onAttr (name, value, options) {
  // do nothing
}

/**
 * 匹配到不在白名单上的一个属性时
 *
 * @param {String} name
 * @param {String} value
 * @param {Object} options
 * @return {String}
 */
function onIgnoreAttr (name, value, options) {
  // do nothing
}

var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;

/**
 * 过滤属性值
 *
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function safeAttrValue(name, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value)) return '';
  return value;
}


exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onAttr = onAttr;
exports.onIgnoreAttr = onIgnoreAttr;
exports.safeAttrValue = safeAttrValue;


/***/ }),

/***/ "0Zbq":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var FilterCSS = __webpack_require__("huvo");


/**
 * XSS过滤
 *
 * @param {String} css 要过滤的CSS代码
 * @param {Object} options 选项：whiteList, onAttr, onIgnoreAttr
 * @return {String}
 */
function filterCSS (html, options) {
  var xss = new FilterCSS(options);
  return xss.process(html);
}


// 输出
exports = module.exports = filterCSS;
exports.FilterCSS = FilterCSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];

// 在浏览器端使用
if (typeof window !== 'undefined') {
  window.filterCSS = module.exports;
}


/***/ }),

/***/ "1fVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3XGG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bdlu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E4I8":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_E4I8__;

/***/ }),

/***/ "FVwl":
/***/ (function(module, exports, __webpack_require__) {

/**
 * filter xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = __webpack_require__("noAI");

/**
 * returns `true` if the input value is `undefined` or `null`
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull(obj) {
  return obj === undefined || obj === null;
}

/**
 * get attributes for a tag
 *
 * @param {String} html
 * @return {Object}
 *   - {String} html
 *   - {Boolean} closing
 */
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/"
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing = html[html.length - 1] === "/";
  if (isClosing) html = _.trim(html.slice(0, -1));
  return {
    html: html,
    closing: isClosing
  };
}

/**
 * shallow copy
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * FilterXSS class
 *
 * @param {Object} options
 *        whiteList, onTag, onTagAttr, onIgnoreTag,
 *        onIgnoreTagAttr, safeAttrValue, escapeHtml
 *        stripIgnoreTagBody, allowCommentTag, stripBlankChar
 *        css{whiteList, onAttr, onIgnoreAttr} `css=false` means don't use `cssfilter`
 */
function FilterXSS(options) {
  options = shallowCopyObject(options || {});

  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }

  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;

  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}

/**
 * start process and returns result
 *
 * @param {String} html
 * @return {String}
 */
FilterXSS.prototype.process = function(html) {
  // compatible with the input
  html = html || "";
  html = html.toString();
  if (!html) return "";

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag = options.onTag;
  var onIgnoreTag = options.onIgnoreTag;
  var onTagAttr = options.onTagAttr;
  var onIgnoreTagAttr = options.onIgnoreTagAttr;
  var safeAttrValue = options.safeAttrValue;
  var escapeHtml = options.escapeHtml;
  var cssFilter = me.cssFilter;

  // remove invisible characters
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }

  // remove html comments
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }

  // if enable stripIgnoreTagBody
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    var stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag
    );
    onIgnoreTag = stripIgnoreTagBody.onIgnoreTag;
  }

  var retHtml = parseTag(
    html,
    function(sourcePosition, position, tag, html, isClosing) {
      var info = {
        sourcePosition: sourcePosition,
        position: position,
        isClosing: isClosing,
        isWhite: whiteList.hasOwnProperty(tag)
      };

      // call `onTag()`
      var ret = onTag(tag, html, info);
      if (!isNull(ret)) return ret;

      if (info.isWhite) {
        if (info.isClosing) {
          return "</" + tag + ">";
        }

        var attrs = getAttrs(html);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function(name, value) {
          // call `onTagAttr()`
          var isWhiteAttr = _.indexOf(whiteAttrList, name) !== -1;
          var ret = onTagAttr(tag, name, value, isWhiteAttr);
          if (!isNull(ret)) return ret;

          if (isWhiteAttr) {
            // call `safeAttrValue()`
            value = safeAttrValue(tag, name, value, cssFilter);
            if (value) {
              return name + '="' + value + '"';
            } else {
              return name;
            }
          } else {
            // call `onIgnoreTagAttr()`
            var ret = onIgnoreTagAttr(tag, name, value, isWhiteAttr);
            if (!isNull(ret)) return ret;
            return;
          }
        });

        // build new tag html
        var html = "<" + tag;
        if (attrsHtml) html += " " + attrsHtml;
        if (attrs.closing) html += " /";
        html += ">";
        return html;
      } else {
        // call `onIgnoreTag()`
        var ret = onIgnoreTag(tag, html, info);
        if (!isNull(ret)) return ret;
        return escapeHtml(html);
      }
    },
    escapeHtml
  );

  // if enable stripIgnoreTagBody
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }

  return retHtml;
};

module.exports = FilterXSS;


/***/ }),

/***/ "I3Iz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "I9N9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmof":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_Jmof__;

/***/ }),

/***/ "NG4M":
/***/ (function(module, exports, __webpack_require__) {

/**
 * xss
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("oz9r");
var parser = __webpack_require__("krhF");
var FilterXSS = __webpack_require__("FVwl");

/**
 * filter xss function
 *
 * @param {String} html
 * @param {Object} options { whiteList, onTag, onTagAttr, onIgnoreTag, onIgnoreTagAttr, safeAttrValue, escapeHtml }
 * @return {String}
 */
function filterXSS(html, options) {
  var xss = new FilterXSS(options);
  return xss.process(html);
}

exports = module.exports = filterXSS;
exports.FilterXSS = FilterXSS;
for (var i in DEFAULT) exports[i] = DEFAULT[i];
for (var i in parser) exports[i] = parser[i];

// using `xss` on the browser, output `filterXSS` to the globals
if (typeof window !== "undefined") {
  window.filterXSS = module.exports;
}


/***/ }),

/***/ "PbPb":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_PbPb__;

/***/ }),

/***/ "R5aA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RIUQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T9WB":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_T9WB__;

/***/ }),

/***/ "Uo+f":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var _ = __webpack_require__("jCb9");


/**
 * 解析style
 *
 * @param {String} css
 * @param {Function} onAttr 处理属性的函数
 *   参数格式： function (sourcePosition, position, name, value, source)
 * @return {String}
 */
function parseStyle (css, onAttr) {
  css = _.trimRight(css);
  if (css[css.length - 1] !== ';') css += ';';
  var cssLength = css.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = '';

  function addNewAttr () {
    // 如果没有正常的闭合圆括号，则直接忽略当前属性
    if (!isParenthesisOpen) {
      var source = _.trim(css.slice(lastPos, i));
      var j = source.indexOf(':');
      if (j !== -1) {
        var name = _.trim(source.slice(0, j));
        var value = _.trim(source.slice(j + 1));
        // 必须有属性名称
        if (name) {
          var ret = onAttr(lastPos, retCSS.length, name, value, source);
          if (ret) retCSS += ret + '; ';
        }
      }
    }
    lastPos = i + 1;
  }

  for (; i < cssLength; i++) {
    var c = css[i];
    if (c === '/' && css[i + 1] === '*') {
      // 备注开始
      var j = css.indexOf('*/', i + 2);
      // 如果没有正常的备注结束，则后面的部分全部跳过
      if (j === -1) break;
      // 直接将当前位置调到备注结尾，并且初始化状态
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c === '(') {
      isParenthesisOpen = true;
    } else if (c === ')') {
      isParenthesisOpen = false;
    } else if (c === ';') {
      if (isParenthesisOpen) {
        // 在圆括号里面，忽略
      } else {
        addNewAttr();
      }
    } else if (c === '\n') {
      addNewAttr();
    }
  }

  return _.trim(retCSS);
}

module.exports = parseStyle;


/***/ }),

/***/ "ZMEE":
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__("PbPb"),__webpack_require__("h4G9"),__webpack_require__("jPm4")):"function"===typeof define&&define.amd?define(["lodash","@fiverr/i18n/singleton","@fiverr/gofor"],e):"object"===typeof exports?exports.FilerrUploader=e(require("lodash"),require("@fiverr/i18n/singleton"),require("@fiverr/gofor")):t.FilerrUploader=e(t._,t.i18n,t.goforFactory)}("undefined"!==typeof self?self:this,function(t,e,n){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,e),o.l=!0,o.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="https://npm-assets.fiverrcdn.com/assets/@fiverr/filerr_uploader/",e(e.s="lVK7")}({GpYf:function(t,e,n){"use strict";var r=function(t){return Array.from(t).map(function(t){return t.charCodeAt(0)})},o=r("META-INF/mozilla.rsa"),i=r("[Content_Types].xml"),u=r("_rels/.rels");t.exports=function(t){var e=t instanceof Uint8Array?t:new Uint8Array(t);if(!(e&&e.length>1))return null;var n=function(t,n){n=Object.assign({offset:0},n);for(var r=0;r<t.length;r++)if(n.mask){if(t[r]!==(n.mask[r]&e[r+n.offset]))return!1}else if(t[r]!==e[r+n.offset])return!1;return!0},s=function(t,e){return n(r(t),e)};if(n([255,216,255]))return{ext:"jpg",mime:"image/jpeg"};if(n([137,80,78,71,13,10,26,10]))return{ext:"png",mime:"image/png"};if(n([71,73,70]))return{ext:"gif",mime:"image/gif"};if(n([87,69,66,80],{offset:8}))return{ext:"webp",mime:"image/webp"};if(n([70,76,73,70]))return{ext:"flif",mime:"image/flif"};if((n([73,73,42,0])||n([77,77,0,42]))&&n([67,82],{offset:8}))return{ext:"cr2",mime:"image/x-canon-cr2"};if(n([73,73,42,0])||n([77,77,0,42]))return{ext:"tif",mime:"image/tiff"};if(n([66,77]))return{ext:"bmp",mime:"image/bmp"};if(n([73,73,188]))return{ext:"jxr",mime:"image/vnd.ms-photo"};if(n([56,66,80,83]))return{ext:"psd",mime:"image/vnd.adobe.photoshop"};if(n([80,75,3,4])){if(n([109,105,109,101,116,121,112,101,97,112,112,108,105,99,97,116,105,111,110,47,101,112,117,98,43,122,105,112],{offset:30}))return{ext:"epub",mime:"application/epub+zip"};if(n(o,{offset:30}))return{ext:"xpi",mime:"application/x-xpinstall"};if(s("mimetypeapplication/vnd.oasis.opendocument.text",{offset:30}))return{ext:"odt",mime:"application/vnd.oasis.opendocument.text"};if(s("mimetypeapplication/vnd.oasis.opendocument.spreadsheet",{offset:30}))return{ext:"ods",mime:"application/vnd.oasis.opendocument.spreadsheet"};if(s("mimetypeapplication/vnd.oasis.opendocument.presentation",{offset:30}))return{ext:"odp",mime:"application/vnd.oasis.opendocument.presentation"};if(n(i,{offset:30})||n(u,{offset:30})){var a=e.subarray(4,2004),c=function(t){return t.findIndex(function(t,e,n){return 80===n[e]&&75===n[e+1]&&3===n[e+2]&&4===n[e+3]})},f=c(a);if(-1!==f){var l=e.subarray(f+8,f+8+1e3),p=c(l);if(-1!==p){var h=8+f+p+30;if(s("word/",{offset:h}))return{ext:"docx",mime:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"};if(s("ppt/",{offset:h}))return{ext:"pptx",mime:"application/vnd.openxmlformats-officedocument.presentationml.presentation"};if(s("xl/",{offset:h}))return{ext:"xlsx",mime:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}}}}}if(n([80,75])&&(3===e[2]||5===e[2]||7===e[2])&&(4===e[3]||6===e[3]||8===e[3]))return{ext:"zip",mime:"application/zip"};if(n([117,115,116,97,114],{offset:257}))return{ext:"tar",mime:"application/x-tar"};if(n([82,97,114,33,26,7])&&(0===e[6]||1===e[6]))return{ext:"rar",mime:"application/x-rar-compressed"};if(n([31,139,8]))return{ext:"gz",mime:"application/gzip"};if(n([66,90,104]))return{ext:"bz2",mime:"application/x-bzip2"};if(n([55,122,188,175,39,28]))return{ext:"7z",mime:"application/x-7z-compressed"};if(n([120,1]))return{ext:"dmg",mime:"application/x-apple-diskimage"};if(n([51,103,112,53])||n([0,0,0])&&n([102,116,121,112],{offset:4})&&(n([109,112,52,49],{offset:8})||n([109,112,52,50],{offset:8})||n([105,115,111,109],{offset:8})||n([105,115,111,50],{offset:8})||n([109,109,112,52],{offset:8})||n([77,52,86],{offset:8})||n([100,97,115,104],{offset:8})))return{ext:"mp4",mime:"video/mp4"};if(n([77,84,104,100]))return{ext:"mid",mime:"audio/midi"};if(n([26,69,223,163])){var d=e.subarray(4,4100),y=d.findIndex(function(t,e,n){return 66===n[e]&&130===n[e+1]});if(-1!==y){var m=y+3,b=function(t){return Array.from(t).every(function(t,e){return d[m+e]===t.charCodeAt(0)})};if(b("matroska"))return{ext:"mkv",mime:"video/x-matroska"};if(b("webm"))return{ext:"webm",mime:"video/webm"}}}if(n([0,0,0,20,102,116,121,112,113,116,32,32])||n([102,114,101,101],{offset:4})||n([102,116,121,112,113,116,32,32],{offset:4})||n([109,100,97,116],{offset:4})||n([119,105,100,101],{offset:4}))return{ext:"mov",mime:"video/quicktime"};if(n([82,73,70,70])&&n([65,86,73],{offset:8}))return{ext:"avi",mime:"video/x-msvideo"};if(n([48,38,178,117,142,102,207,17,166,217]))return{ext:"wmv",mime:"video/x-ms-wmv"};if(n([0,0,1,186])||n([0,0,1,179]))return{ext:"mpg",mime:"video/mpeg"};if(n([102,116,121,112,51,103],{offset:4}))return{ext:"3gp",mime:"video/3gpp"};for(var v=0;v<2&&v<e.length-16;v++){if(n([73,68,51],{offset:v})||n([255,226],{offset:v,mask:[255,226]}))return{ext:"mp3",mime:"audio/mpeg"};if(n([255,228],{offset:v,mask:[255,228]}))return{ext:"mp2",mime:"audio/mpeg"}}if(n([102,116,121,112,77,52,65],{offset:4})||n([77,52,65,32]))return{ext:"m4a",mime:"audio/m4a"};if(n([79,112,117,115,72,101,97,100],{offset:28}))return{ext:"opus",mime:"audio/opus"};if(n([79,103,103,83]))return n([128,116,104,101,111,114,97],{offset:28})?{ext:"ogv",mime:"video/ogg"}:n([1,118,105,100,101,111,0],{offset:28})?{ext:"ogm",mime:"video/ogg"}:n([127,70,76,65,67],{offset:28})?{ext:"oga",mime:"audio/ogg"}:n([83,112,101,101,120,32,32],{offset:28})?{ext:"spx",mime:"audio/ogg"}:n([1,118,111,114,98,105,115],{offset:28})?{ext:"ogg",mime:"audio/ogg"}:{ext:"ogx",mime:"application/ogg"};if(n([102,76,97,67]))return{ext:"flac",mime:"audio/x-flac"};if(n([82,73,70,70])&&n([87,65,86,69],{offset:8}))return{ext:"wav",mime:"audio/x-wav"};if(n([35,33,65,77,82,10]))return{ext:"amr",mime:"audio/amr"};if(n([37,80,68,70]))return{ext:"pdf",mime:"application/pdf"};if(n([77,90]))return{ext:"exe",mime:"application/x-msdownload"};if((67===e[0]||70===e[0])&&n([87,83],{offset:1}))return{ext:"swf",mime:"application/x-shockwave-flash"};if(n([123,92,114,116,102]))return{ext:"rtf",mime:"application/rtf"};if(n([0,97,115,109]))return{ext:"wasm",mime:"application/wasm"};if(n([119,79,70,70])&&(n([0,1,0,0],{offset:4})||n([79,84,84,79],{offset:4})))return{ext:"woff",mime:"font/woff"};if(n([119,79,70,50])&&(n([0,1,0,0],{offset:4})||n([79,84,84,79],{offset:4})))return{ext:"woff2",mime:"font/woff2"};if(n([76,80],{offset:34})&&(n([0,0,1],{offset:8})||n([1,0,2],{offset:8})||n([2,0,2],{offset:8})))return{ext:"eot",mime:"application/octet-stream"};if(n([0,1,0,0,0]))return{ext:"ttf",mime:"font/ttf"};if(n([79,84,84,79,0]))return{ext:"otf",mime:"font/otf"};if(n([0,0,1,0]))return{ext:"ico",mime:"image/x-icon"};if(n([0,0,2,0]))return{ext:"cur",mime:"image/x-icon"};if(n([70,76,86,1]))return{ext:"flv",mime:"video/x-flv"};if(n([37,33]))return{ext:"ps",mime:"application/postscript"};if(n([253,55,122,88,90,0]))return{ext:"xz",mime:"application/x-xz"};if(n([83,81,76,105]))return{ext:"sqlite",mime:"application/x-sqlite3"};if(n([78,69,83,26]))return{ext:"nes",mime:"application/x-nintendo-nes-rom"};if(n([67,114,50,52]))return{ext:"crx",mime:"application/x-google-chrome-extension"};if(n([77,83,67,70])||n([73,83,99,40]))return{ext:"cab",mime:"application/vnd.ms-cab-compressed"};if(n([33,60,97,114,99,104,62,10,100,101,98,105,97,110,45,98,105,110,97,114,121]))return{ext:"deb",mime:"application/x-deb"};if(n([33,60,97,114,99,104,62]))return{ext:"ar",mime:"application/x-unix-archive"};if(n([237,171,238,219]))return{ext:"rpm",mime:"application/x-rpm"};if(n([31,160])||n([31,157]))return{ext:"Z",mime:"application/x-compress"};if(n([76,90,73,80]))return{ext:"lz",mime:"application/x-lzip"};if(n([208,207,17,224,161,177,26,225]))return{ext:"msi",mime:"application/x-msi"};if(n([6,14,43,52,2,5,1,1,13,1,2,1,1,2]))return{ext:"mxf",mime:"application/mxf"};if(n([71],{offset:4})&&(n([71],{offset:192})||n([71],{offset:196})))return{ext:"mts",mime:"video/mp2t"};if(n([66,76,69,78,68,69,82]))return{ext:"blend",mime:"application/x-blender"};if(n([66,80,71,251]))return{ext:"bpg",mime:"image/bpg"};if(n([0,0,0,12,106,80,32,32,13,10,135,10])){if(n([106,112,50,32],{offset:20}))return{ext:"jp2",mime:"image/jp2"};if(n([106,112,120,32],{offset:20}))return{ext:"jpx",mime:"image/jpx"};if(n([106,112,109,32],{offset:20}))return{ext:"jpm",mime:"image/jpm"};if(n([109,106,112,50],{offset:20}))return{ext:"mj2",mime:"image/mj2"}}if(n([70,79,82,77,0]))return{ext:"aif",mime:"audio/aiff"};if(s("<?xml "))return{ext:"xml",mime:"application/xml"};if(n([66,79,79,75,77,79,66,73],{offset:60}))return{ext:"mobi",mime:"application/x-mobipocket-ebook"};if(n([102,116,121,112],{offset:4})){if(n([109,105,102,49],{offset:8}))return{ext:"heic",mime:"image/heif"};if(n([109,115,102,49],{offset:8}))return{ext:"heic",mime:"image/heif-sequence"};if(n([104,101,105,99],{offset:8})||n([104,101,105,120],{offset:8}))return{ext:"heic",mime:"image/heic"};if(n([104,101,118,99],{offset:8})||n([104,101,118,120],{offset:8}))return{ext:"heic",mime:"image/heic-sequence"}}return null}},PbPb:function(e,n){e.exports=t},h4G9:function(t,n){t.exports=e},jPm4:function(t,e){t.exports=n},lVK7:function(t,e,n){"use strict";function r(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new Date,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.prefix,r=void 0===n?At:n,o=Date.now(),i=o-t;return Number.isNaN(i)?"":i<_t&&Tt(r,"just_now")||i<xt&&Tt(r,"minutes_ago",i/_t)||i<Pt&&Tt(r,"hours_ago",i/xt)||i<St&&Tt(r,"days_ago",i/Pt)||i<Ot&&Tt(r,"weeks_ago",i/St)||i<jt&&Tt(r,"months_ago",i/Ot)||Tt(r,"years_ago",i/jt)}function o(t){function e(t,e){return n[t]=n.hasOwnProperty(t)?n[t]:e()}for(var n={},r=arguments.length,o=Array(r>1?r-1:0),u=1;u<r;u++)o[u-1]=arguments[u];o.forEach(function(n){return i.call(t,n,e)})}function i(t,e){var n=this,r=Object.getOwnPropertyDescriptor(this.constructor.prototype,t),o=Ut.reduce(function(o,i){switch(Dt(r[i])){case"undefined":break;case"function":Lt.includes(i)?o[i]=function(){return e(t+"$"+i,r[i].bind(n))}:o[i]=r[i];break;default:o[i]=r[i]}return o},{});Object.defineProperty(this,t,o)}function u(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t){var e=t.getBoundingClientRect(),n=e.width,r=e.height;if(0!==n||0!==r)return null;for(;t;){if(t===document.body)return null;if("none"===window.getComputedStyle(t).display)return t;t=t.parentElement}return t}function a(t){if(t instanceof Window||t instanceof HTMLDocument)return{left:0,top:0,right:window.innerWidth,bottom:window.innerHeight,width:window.innerWidth,height:window.innerHeight};var e=t.getBoundingClientRect();return{left:e.left,top:e.top,right:e.right,bottom:e.bottom,width:e.width,height:e.height}}function c(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},n=e.container,r=void 0===n?window:n,o=e.percent,i=void 0===o?50:o,u=a(t),s=a(r),c=i/100,f=function(t){var e=Gt(t,3),n=e[0],r=e[1];return(0,e[2])(u[n],s[n])+u[r]>=u[r]*c};return!["width","height"].some(function(t){return 0===u[t]})&&[["top","height",Xt],["left","width",Xt],["right","width",Yt],["bottom","height",Yt]].every(f)}function f(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function l(t){try{return JSON.parse(JSON.stringify(t))}catch(t){throw new SyntaxError("Data was expected to be valid for JSON. Got error: "+t)}}function p(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function h(){var t=ee.get(oe);t&&(Kt.apply(void 0,p(t)),ee.set(oe,[]))}function d(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function y(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function m(){var t=new Headers;t.append("X-Requested-With","XMLHttpRequest"),t.append("Content-Type","application/json; charset=utf-8"),t.append("Accept","application/json");try{t.append("X-CSRF-Token",document.AUTH_TOKEN)}catch(t){}return t}function b(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return!1},n={};for(var r in t)e(r,t[r])&&(n[r]=t[r]);return n}function v(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=(""+Math.random()).slice(-8)+(""+Date.now()).slice(8);return(t?t+"_":"")+e}function g(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function w(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!==typeof e&&"function"!==typeof e?t:e}function _(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function x(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function P(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function S(t){var e=t.split("="),n=ge(e,2),r=n[0],o=n[1];return""===r?{}:P({},r,ve(o))}function O(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function j(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function E(t,e){return function(n){var r=n.match(t);return r&&r[e]||""}}function k(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function A(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}function T(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function N(t,e,n){return!(arguments.length>3&&void 0!==arguments[3]&&arguments[3])&&t.store.hasOwnProperty(e)||(t[ke]=Object.freeze(Object.assign({},t.store,T({},e,n())))),t}function I(t){for(var e=arguments.length,n=Array(e>1?e-1:0),r=1;r<e;r++)n[r-1]=arguments[r];return t[ke]=Object.freeze(Object.assign.apply(Object,A([{href:[t.path,t.hasQueryParams()?"?"+xe(t.queryParams):"",t.hasHashParams()?"#"+xe(t.hashParams):""].join("")}].concat(n.map(function(e){return T({},e,t.store[e])}))))),t}function q(t,e){function n(){this.constructor=t}Te(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}function C(t){return"function"===typeof t}function D(t){setTimeout(function(){throw t})}function U(t){return null!=t&&"object"===typeof t}function L(){try{return ue.apply(this,arguments)}catch(t){return De.e=t,De}}function M(t){return ue=t,L}function R(t){return t.reduce(function(t,e){return t.concat(e instanceof Ue?e.errors:e)},[])}function F(t){return t instanceof Re||"syncErrorThrowable"in t&&t[Me]}function H(t,e,n){if(t){if(t instanceof Re)return t;if(t[Me])return t[Me]()}return t||e||n?new Re(t,e,n):new Re(qe)}function z(){}function G(t){return t?1===t.length?t[0]:function(e){return t.reduce(function(t,e){return e(t)},e)}:z}function X(t){if(t||(t=Ie.Promise||Promise),!t)throw new Error("no Promise impl found");return t}function Y(){return function(t){return t.lift(new Xe(t))}}function V(t){return t?W(t):Ze}function W(t){return new ze(function(e){return t.schedule(function(){return e.complete()})})}function B(t,e){return new ze(e?function(n){var r=new Le,o=0;return r.add(e.schedule(function(){if(o===t.length)return void n.complete();n.next(t[o++]),n.closed||r.add(this.schedule())})),r}:tn(t))}function J(t,e){return function(n){if("function"!==typeof t)throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");return n.lift(new nn(t,e))}}function $(t){return t&&"function"!==typeof t.subscribe&&"function"===typeof t.then}function K(t){return t&&"function"===typeof t[He]}function Q(t){return t&&"function"===typeof t[un]}function Z(t,e){return new ze(e?function(n){var r=new Le;return r.add(e.schedule(function(){return t.then(function(t){r.add(e.schedule(function(){n.next(t),r.add(e.schedule(function(){return n.complete()}))}))},function(t){r.add(e.schedule(function(){return n.error(t)}))})})),r}:on(t))}function tt(t,e){if(!t)throw new Error("Iterable cannot be null");return new ze(e?function(n){var r,o=new Le;return o.add(function(){r&&"function"===typeof r.return&&r.return()}),o.add(e.schedule(function(){r=t[un](),o.add(e.schedule(function(){if(!n.closed){var t,e;try{var o=r.next();t=o.value,e=o.done}catch(t){return void n.error(t)}e?n.complete():(n.next(t),this.schedule())}}))})),o}:sn(t))}function et(t,e){return new ze(e?function(n){var r=new Le;return r.add(e.schedule(function(){var o=t[He]();r.add(o.subscribe({next:function(t){r.add(e.schedule(function(){return n.next(t)}))},error:function(t){r.add(e.schedule(function(){return n.error(t)}))},complete:function(){r.add(e.schedule(function(){return n.complete()}))}}))})),r}:an(t))}function nt(t,e){if(!e)return t instanceof ze?t:new ze(fn(t));if(null!=t){if(K(t))return et(t,e);if($(t))return Z(t,e);if(cn(t))return B(t,e);if(Q(t)||"string"===typeof t)return tt(t,e)}throw new TypeError((null!==t&&typeof t||t)+" is not observable")}function rt(t){return new ze(function(e){var n;try{n=t()}catch(t){return void e.error(t)}return(n?nt(n):V()).subscribe(e)})}function ot(t){return!Ce(t)&&t-parseFloat(t)+1>=0}function it(t){var e=t.subscriber,n=t.counter,r=t.period;e.next(n),this.schedule({subscriber:e,counter:n+1,period:r},r)}function ut(t,e){var n=!1;return arguments.length>=2&&(n=!0),function(r){return r.lift(new ln(t,e,n))}}function st(t){return void 0===t&&(t=-1),function(e){return e.lift(new hn(t,e))}}function at(t){return void 0===t&&(t=en),function(e){return rt(function(){return e.pipe(ut(function(e,n){var r=e.current;return{value:n,current:t.now(),last:r}},{current:t.now(),value:void 0,last:void 0}),J(function(t){var e=t.current,n=t.last,r=t.value;return new yn(r,e-n)}))})}}function ct(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function ft(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!==typeof e&&"function"!==typeof e?t:e}function lt(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function pt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function ht(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function dt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function yt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function mt(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!==typeof e&&"function"!==typeof e?t:e}function bt(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}function vt(t){return new Promise(function(e,n){var r=new FileReader;r.onloadend=function(n){if(n.target.readyState===FileReader.DONE){var r=new Uint8Array(n.target.result),o=Tn(r);e(o?o.mime:t.type)}},r.onerror=function(t){return n(new vn(t.code,t.message,mn.GET_POLICY))};var o=t.slice(0,4);r.readAsArrayBuffer(o)})}function gt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function wt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var _t=("function"===typeof Symbol&&Symbol.iterator,6e4),xt=36e5,Pt=864e5,St=6048e5,Ot=2592e6,jt=31536e6,Et=n("h4G9"),kt=n.n(Et),At="general.how_long_ago.",Tt=function(t,e){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;return kt.a.t(""+t+e,{count:Math.floor(n)})};Object.assign(r,{MINUTE_IN_MS:_t,HOUR_IN_MS:xt,DAY_IN_MS:Pt,WEEK_IN_MS:St,MONTH_IN_MS:Ot,YEAR_IN_MS:jt});var Nt=(function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,s=t[Symbol.iterator]();!(r=(u=s.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}return n}}(),"function"===typeof Symbol&&Symbol.iterator,"function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t}),It="object"===("undefined"===typeof window?"undefined":Nt(window))&&window.window===window&&window||"object"===("undefined"===typeof GLOBAL?"undefined":Nt(GLOBAL))&&GLOBAL.GLOBAL===GLOBAL&&GLOBAL||"object"===("undefined"===typeof self?"undefined":Nt(self))&&self.self===self&&self,qt="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Ct=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:It;return t.split(".").reduce(function(t,e){return"object"===("undefined"===typeof t?"undefined":qt(t))?t[e]:t},e)},Dt="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Ut=["get","value","set","configurable","enumerable","writable"],Lt=["get","value"],Mt="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Rt=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),Ft=function(){function t(){u(this,t),o(this,"node","browser","development","production","testing","jest","plike","toString")}return Rt(t,[{key:"toString",value:function(){return(Ct(this.browser?"app.environment":"process.env.NODE_ENV")||"").toLowerCase()}},{key:"node",get:function(){return"[object process]"===Object.prototype.toString.call("undefined"!==typeof It.process?It.process:0)}},{key:"browser",get:function(){return this.jest||!this.node&&["undefined"===typeof document?"undefined":Mt(document),"undefined"===typeof window?"undefined":Mt(window)].every(function(t){return"undefined"!==t})}},{key:"development",get:function(){return this.toString().includes("dev")}},{key:"dev",get:function(){return this.development}},{key:"production",get:function(){return this.toString().includes("prod")}},{key:"prod",get:function(){return this.production}},{key:"testing",get:function(){return this.toString().includes("test")}},{key:"test",get:function(){return this.testing}},{key:"jest",get:function(){return(Ct("process.env.npm_lifecycle_script")||"").toString().includes("jest")}},{key:"plike",get:function(){return this.toString().includes("like")}}]),t}(),Ht=new Ft,zt=function(t){return new Promise(function(e,n){Ht.browser||n("emerge can not be triggered from a non browser environment");var r=s(t);if(null===r)return void e(t);if("undefined"===typeof MutationObserver)return void e(t);var o=new MutationObserver(function(){null===s(t)&&(e(t),o.disconnect())});o.observe(r,{attributes:!0})})},Gt=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,s=t[Symbol.iterator]();!(r=(u=s.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),Xt=function(t,e){return t-e},Yt=function(t,e){return e-t},Vt=n("PbPb"),Wt=n.n(Vt),Bt="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Jt=function(t){return"object"===("undefined"===typeof Fiverr?"undefined":Bt(Fiverr))&&"function"===typeof Fiverr[t]||void 0},$t=function(t){return function(){var e;return Jt(t)&&(e=Fiverr)[t].apply(e,arguments)}},Kt=$t("sendClientEvents"),Qt=$t("_logEventToGraphite"),Zt=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),te=function(){function t(e){var n=this;f(this,t),o(this,"available"),this.storage=Ht.browser&&window[e],["get","set"].forEach(function(t){return n[t]=n[t].bind(n)})}return Zt(t,[{key:"get",value:function(t){if(this.available){var e=this.storage.getItem(t);try{return JSON.parse(e)}catch(t){return e}}}},{key:"set",value:function(t,e){var n=this;return this.available?new Promise(function(r,o){try{n.storage.setItem(t,JSON.stringify(e)),r()}catch(t){o(t)}}):new Promise(function(t){return t})}},{key:"remove",value:function(t){this.available&&this.storage.removeItem(t)}},{key:"size",value:function(){for(var t=this,e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];var o=!n.length,i=0;o&&(n=Array.from(Array(this.storage.length)).map(function(e,n){return t.storage.key(n)}));var u=n.reduce(function(e,n){var r=(n+t.storage.getItem(n)).length;return e[n]=r,o&&(i+=r),e},{});return o&&Object.assign(u,{total:i}),u}},{key:"available",get:function(){if(!Ht.browser)return!1;var t=Math.random().toString(36).substring(2);try{return this.storage.setItem(t,!0),this.storage.removeItem(t),!0}catch(t){return!1}}}]),t}(),ee=new te("localStorage"),ne=(new te("sessionStorage"),200),re={capture:!1,once:!1,passive:!1},oe="impressionable_events",ie=["load","resize","scroll","touchmove"];try{h.throttled=Wt.a.throttle(h,500,{leading:!1}),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",h,{once:!0}):h(),window.addEventListener("beforeunload",h,{once:!0})}catch(t){}var ue,se="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},ae=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),ce={data:[],container:"undefined"!==typeof window?window:null,DOMAttribute:"id",dataIdentifier:"id"},fe=(function(){function t(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};if(y(this,t),!Ht.browser)throw new Error("Impressionable can not be instantiated from a non browser environment");this.options=Object.assign({},ce,e),this.options.DOMSelector=this.options.DOMSelector||"["+this.options.DOMAttribute+"]";var n=this.options,r=n.data,o=n.container,i=n.DOMSelector,u=n.dataProperty,s=n.dataIdentifier;if(!Array.isArray(r))throw new TypeError('Impressionable must receive a "data" array argument. Got '+("undefined"===typeof r?"undefined":se(r)));var a=o===window?document.body:o;if(!a)throw new Error("Impressionable container (when passed) expects a DOM element. Got a "+("undefined"===typeof o?"undefined":se(o)));var c=a.querySelectorAll(i);Object.assign(this,{container:o,impressed:[],unimpressed:[].slice.call(c)}),this.data=this.options.data.reduce(function(t,e,n){return e.hasOwnProperty(s)&&(t[e[s]]=Object.assign({$index:n},l(u?Wt.a.get(e,u):e))),t},{}),this.collect=Wt.a.throttle(this.collect.bind(this),ne,{leading:!1}),this.live()}ae(t,[{key:"collect",value:function(){for(var t=this.container,e=t===window||c(t,{percent:100}),n=[],r=this.unimpressed.length;r--;){var o=this.unimpressed[r];if(c(o,{container:t})&&(e||c(o))){var i=this.getImpressionData(o);i?(n.push(i),o.setAttribute("data-impression-collected","true")):o.setAttribute("data-impression-collected","error"),this.impress(r)}}return n.length&&(this.storeImpressions.apply(this,n),h.throttled()),this}},{key:"impress",value:function(t){var e;(e=this.impressed).push.apply(e,d(this.unimpressed.splice(t,1))),this.unimpressed.length||this.retire()}},{key:"getImpressionData",value:function(t){var e=t.getAttribute(this.options.DOMAttribute),n=this.data[e];if("function"===typeof this.options.enrich){var r=this.options.enrich(n,t);"object"!==("undefined"===typeof r?"undefined":se(r))&&!1!==r||(n=r)}return n}},{key:"storeImpressions",value:function(){for(var t=arguments.length,e=Array(t),n=0;n<t;n++)e[n]=arguments[n];if(!ee.available)return void Kt.apply(void 0,e);this.stored=e}},{key:"live",value:function(){var t=this;this.containerEvents.forEach(function(e){return t.container.addEventListener(e,t.collect,re)}),ie.forEach(function(e){return window.addEventListener(e,t.collect,re)}),zt(this.container).then(this.collect).catch(function(t){throw t})}},{key:"die",value:function(){var t=this;this.containerEvents.forEach(function(e){return t.container.removeEventListener(e,t.collect,re)}),ie.forEach(function(e){return window.removeEventListener(e,t.collect,re)})}},{key:"retire",value:function(){this.retired||Object.assign(this,{impressed:[],unimpressed:[],data:{},options:{},retired:!0}).die()}},{key:"stored",get:function(){return ee.get(oe)||[]},set:function(t){var e=this.stored;e.push.apply(e,d(t)),ee.set(oe,e).catch(function(){Kt.apply(void 0,d(e)),ee.remove(oe),Qt({label:"fe_events.error.impressionable.localstorage",timing:ee.size(oe)[oe],percentage:100})})}},{key:"containerEvents",get:function(){var t=["collect-impressions"];return this.container!==window&&t.push("scroll","touchmove"),t}}],[{key:"CUSTOM_EVENT",get:function(){return"collect-impressions"}}])}(),n("jPm4")),le=n.n(fe),pe=function(){return{credentials:"same-origin",headers:m()}},he=le()(pe),de=("function"===typeof Symbol&&Symbol.iterator,{uid:v}),ye=/[|\\{}()[\]^$+*?.]/g,me=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"";return t.replace(ye,e)},be=(function(t){function e(){var t;g(this,e);for(var n=arguments.length,r=Array(n),o=0;o<n;o++)r[o]=arguments[o];return"string"===typeof r[0]&&(r[0]=me(r[0])),w(this,(t=e.__proto__||Object.getPrototypeOf(e)).call.apply(t,[this].concat(r)))}_(e,t)}(RegExp),$t("_logErrorToServer"),"function"===typeof Symbol&&Symbol.iterator,Object.seal(["string","number"]),function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()),ve=(function(){function t(){if(x(this,t),!Ht.browser)throw new Error("[fUtile][Tab][Constructor] Module should only be used in the browser");this.uid=de.uid("TAB"),this.setActiveTab=this.setActiveTab.bind(this),this.whenActive=new Set,this.focusHandlers=new Map,this.setActiveTab(),this.onFocus(this.setActiveTab)}be(t,[{key:"setActiveTab",value:function(){this.isActive||(ee.set("VdOMGFYWmxYM1JoWWc",this.uid),this.whenActive.forEach(function(t){return t()}))}},{key:"onSetActive",value:function(t){"function"===typeof t&&this.whenActive.add(t)}},{key:"focusSubscribe",value:function(t){if("function"!==typeof t)return null;var e=de.uid();return this.onFocus(t),this.focusHandlers.set(e,t),e}},{key:"focusUnsubscribe",value:function(t){window.removeEventListener("focus",this.focusHandlers.get(t))}},{key:"onFocus",value:function(t){window.addEventListener("focus",t)}},{key:"activeTab",get:function(){return ee.get("VdOMGFYWmxYM1JoWWc")}},{key:"isActive",get:function(){return this.activeTab===this.uid}}])}(),function(t){return void 0===t||decodeURIComponent(t)}),ge=function(){function t(t,e){var n=[],r=!0,o=!1,i=void 0;try{for(var u,s=t[Symbol.iterator]();!(r=(u=s.next()).done)&&(n.push(u.value),!e||n.length!==e);r=!0);}catch(t){o=!0,i=t}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}return n}return function(e,n){if(Array.isArray(e))return e;if(Symbol.iterator in Object(e))return t(e,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}(),we=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";return Object.assign.apply(Object,O(t.split("&").map(S)))},_e=("function"===typeof Symbol&&Symbol.iterator,"function"===typeof Symbol&&Symbol.iterator,function(t){return!0===t?"":"="+encodeURIComponent(t)}),xe=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return Object.keys(t).map(function(e){return e+_e(t[e])}).join("&")},Pe=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),Se={},Oe=function(){function t(){j(this,t)}return Pe(t,[{key:"hash",get:function(){return Se.hash=Se.hash||E(/^.*[\#\!|\#](.*)/,1)}},{key:"query",get:function(){return Se.query=Se.query||E(/^.*\?(.*(?=#)|(.*(?=$)))/,1)}},{key:"host",get:function(){return Se.host=Se.host||E(/^(.*:[\/]{2}|[\/]{2})?([\w|-|\.]*).*$/,2)}},{key:"top",get:function(){return Se.top=Se.top||E(/localhost$|[^.]*\.[^.]{2,3}(?:\.[^.]{2,3})?$/,0)}},{key:"protocol",get:function(){return Se.protocol=Se.protocol||E(/^(.*:)[\/]{2}|[\/]{2}?.*$/,1)}},{key:"path",get:function(){return Se.path=Se.path||function(t){return t.replace(/[\?|#].*$/,"")}}},{key:"pathname",get:function(){return Se.pathname=Se.pathname||function(t,e){return e?t.replace(new RegExp(".*"+e),""):t}}}]),t}(),je=new Oe,Ee=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),ke="function"===typeof Symbol?Symbol():"_store",Ae={"#!":"hashParams","#":"hashParams","?":"queryParams"},Te=(function(){function t(e){k(this,t),this[ke]=Object.freeze({href:e})}Ee(t,[{key:"toString",value:function(){return this.href}},{key:"hasQueryParams",value:function(){return Object.keys(this.queryParams).length>0}},{key:"hasHashParams",value:function(){return Object.keys(this.hashParams).length>0}},{key:"addParams",value:function(t,e){return this.params,this[Ae[e]||"params"]=t,this}},{key:"hasParams",value:function(){return Object.keys(this.params).length>0}},{key:"removeParams",value:function(){for(var t=this,e=arguments.length,n=Array(e),r=0;r<e;r++)n[r]=arguments[r];return this.params,n.length?this[ke]=Object.freeze(Object.assign.apply(Object,A([{},this.store].concat(["hashParams","queryParams"].map(function(e){return T({},e,b(t[e],function(t){return!~n.indexOf(t)}))}))))):this[ke]=Object.freeze(Object.assign.apply(Object,[{},this.store,{hashParams:{},queryParams:{}}])),I(this,"queryParams","hashParams")}},{key:"store",get:function(){return this[ke]}},{key:"href",get:function(){return this.store.href}},{key:"path",get:function(){var t=this;return N(this,"path",function(){return je.path(t.href)}).store.path}},{key:"pathname",get:function(){var t=this;return this.path,this.host,N(this,"pathname",function(){return je.pathname(t.path,t.host)}).store.pathname}},{key:"host",get:function(){var t=this;return this.path,N(this,"host",function(){return je.host(t.path)}).store.host}},{key:"top",get:function(){var t=this;return this.host,N(this,"top",function(){return je.top(t.host)}).store.top}},{key:"protocol",get:function(){var t=this;return this.path,N(this,"protocol",function(){return je.protocol(t.path)}).store.protocol}},{key:"query",get:function(){var t=this;return N(this,"query",function(){return je.query(t.href)}).store.query}},{key:"queryParams",get:function(){var t=this;return this.query,N(this,"queryParams",function(){return Object.freeze(we(t.query))}).store.queryParams},set:function(t){var e=this;this.queryParams,I(N(this,"queryParams",function(){return Object.assign({},e.queryParams,t)},!0),"queryParams")}},{key:"hash",get:function(){var t=this;return N(this,"hash",function(){return je.hash(t.href)}).store.hash}},{key:"hashParams",get:function(){var t=this;return this.hash,N(this,"hashParams",function(){return Object.freeze(we(t.hash))}).store.hashParams},set:function(t){var e=this;this.hashParams,I(N(this,"hashParams",function(){return Object.assign({},e.hashParams,t)},!0),"hashParams")}},{key:"params",get:function(){return this.queryParams,this.hashParams,Object.assign({},this.queryParams,this.hashParams)},set:function(t){this.params,this[(!this.hasQueryParams()&&this.hasHashParams()?"hash":"query")+"Params"]=t}}])}(),Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}),Ne=(Object.assign,!1),Ie={Promise:void 0,set useDeprecatedSynchronousErrorHandling(t){if(t){(new Error).stack}Ne=t},get useDeprecatedSynchronousErrorHandling(){return Ne}},qe={closed:!0,next:function(t){},error:function(t){if(Ie.useDeprecatedSynchronousErrorHandling)throw t;D(t)},complete:function(){}},Ce=Array.isArray||function(t){return t&&"number"===typeof t.length},De={e:{}},Ue=function(t){function e(n){var r=t.call(this,n?n.length+" errors occurred during unsubscription:\n  "+n.map(function(t,e){return e+1+") "+t.toString()}).join("\n  "):"")||this;return r.errors=n,r.name="UnsubscriptionError",Object.setPrototypeOf(r,e.prototype),r}return q(e,t),e}(Error),Le=function(){function t(t){this.closed=!1,this._parent=null,this._parents=null,this._subscriptions=null,t&&(this._unsubscribe=t)}return t.prototype.unsubscribe=function(){var t,e=!1;if(!this.closed){var n=this,r=n._parent,o=n._parents,i=n._unsubscribe,u=n._subscriptions;this.closed=!0,this._parent=null,this._parents=null,this._subscriptions=null;for(var s=-1,a=o?o.length:0;r;)r.remove(this),r=++s<a&&o[s]||null;if(C(i)){var c=M(i).call(this);c===De&&(e=!0,t=t||(De.e instanceof Ue?R(De.e.errors):[De.e]))}if(Ce(u))for(s=-1,a=u.length;++s<a;){var f=u[s];if(U(f)){var c=M(f.unsubscribe).call(f);if(c===De){e=!0,t=t||[];var l=De.e;l instanceof Ue?t=t.concat(R(l.errors)):t.push(l)}}}if(e)throw new Ue(t)}},t.prototype.add=function(e){if(!e||e===t.EMPTY)return t.EMPTY;if(e===this)return this;var n=e;switch(typeof e){case"function":n=new t(e);case"object":if(n.closed||"function"!==typeof n.unsubscribe)return n;if(this.closed)return n.unsubscribe(),n;if("function"!==typeof n._addParent){var r=n;n=new t,n._subscriptions=[r]}break;default:throw new Error("unrecognized teardown "+e+" added to Subscription.")}return(this._subscriptions||(this._subscriptions=[])).push(n),n._addParent(this),n},t.prototype.remove=function(t){var e=this._subscriptions;if(e){var n=e.indexOf(t);-1!==n&&e.splice(n,1)}},t.prototype._addParent=function(t){var e=this,n=e._parent,r=e._parents;n&&n!==t?r?-1===r.indexOf(t)&&r.push(t):this._parents=[t]:this._parent=t},t.EMPTY=function(t){return t.closed=!0,t}(new t),t}(),Me="function"===typeof Symbol&&"function"===typeof Symbol.for?Symbol.for("rxSubscriber"):"@@rxSubscriber",Re=function(t){function e(e,n,r){var o=t.call(this)||this;switch(o.syncErrorValue=null,o.syncErrorThrown=!1,o.syncErrorThrowable=!1,o.isStopped=!1,arguments.length){case 0:o.destination=qe;break;case 1:if(!e){o.destination=qe;break}if("object"===typeof e){if(F(e)){var i=e[Me]();o.syncErrorThrowable=i.syncErrorThrowable,o.destination=i,i.add(o)}else o.syncErrorThrowable=!0,o.destination=new Fe(o,e);break}default:o.syncErrorThrowable=!0,o.destination=new Fe(o,e,n,r)}return o}return q(e,t),e.prototype[Me]=function(){return this},e.create=function(t,n,r){var o=new e(t,n,r);return o.syncErrorThrowable=!1,o},e.prototype.next=function(t){this.isStopped||this._next(t)},e.prototype.error=function(t){this.isStopped||(this.isStopped=!0,this._error(t))},e.prototype.complete=function(){this.isStopped||(this.isStopped=!0,this._complete())},e.prototype.unsubscribe=function(){this.closed||(this.isStopped=!0,t.prototype.unsubscribe.call(this))},e.prototype._next=function(t){this.destination.next(t)},e.prototype._error=function(t){this.destination.error(t),this.unsubscribe()},e.prototype._complete=function(){this.destination.complete(),this.unsubscribe()},e.prototype._unsubscribeAndRecycle=function(){var t=this,e=t._parent,n=t._parents;return this._parent=null,this._parents=null,this.unsubscribe(),this.closed=!1,this.isStopped=!1,this._parent=e,this._parents=n,this},e}(Le),Fe=function(t){function e(e,n,r,o){var i=t.call(this)||this;i._parentSubscriber=e;var u,s=i;return C(n)?u=n:n&&(u=n.next,r=n.error,o=n.complete,n!==qe&&(s=Object.create(n),C(s.unsubscribe)&&i.add(s.unsubscribe.bind(s)),s.unsubscribe=i.unsubscribe.bind(i))),i._context=s,i._next=u,i._error=r,i._complete=o,i}return q(e,t),e.prototype.next=function(t){if(!this.isStopped&&this._next){var e=this._parentSubscriber;Ie.useDeprecatedSynchronousErrorHandling&&e.syncErrorThrowable?this.__tryOrSetError(e,this._next,t)&&this.unsubscribe():this.__tryOrUnsub(this._next,t)}},e.prototype.error=function(t){if(!this.isStopped){var e=this._parentSubscriber,n=Ie.useDeprecatedSynchronousErrorHandling;if(this._error)n&&e.syncErrorThrowable?(this.__tryOrSetError(e,this._error,t),this.unsubscribe()):(this.__tryOrUnsub(this._error,t),this.unsubscribe());else if(e.syncErrorThrowable)n?(e.syncErrorValue=t,e.syncErrorThrown=!0):D(t),this.unsubscribe();else{if(this.unsubscribe(),n)throw t;D(t)}}},e.prototype.complete=function(){var t=this;if(!this.isStopped){var e=this._parentSubscriber;if(this._complete){var n=function(){return t._complete.call(t._context)};Ie.useDeprecatedSynchronousErrorHandling&&e.syncErrorThrowable?(this.__tryOrSetError(e,n),this.unsubscribe()):(this.__tryOrUnsub(n),this.unsubscribe())}else this.unsubscribe()}},e.prototype.__tryOrUnsub=function(t,e){try{t.call(this._context,e)}catch(t){if(this.unsubscribe(),Ie.useDeprecatedSynchronousErrorHandling)throw t;D(t)}},e.prototype.__tryOrSetError=function(t,e,n){if(!Ie.useDeprecatedSynchronousErrorHandling)throw new Error("bad call");try{e.call(this._context,n)}catch(e){return Ie.useDeprecatedSynchronousErrorHandling?(t.syncErrorValue=e,t.syncErrorThrown=!0,!0):(D(e),!0)}return!1},e.prototype._unsubscribe=function(){var t=this._parentSubscriber;this._context=null,this._parentSubscriber=null,t.unsubscribe()},e}(Re),He="function"===typeof Symbol&&Symbol.observable||"@@observable",ze=function(){function t(t){this._isScalar=!1,t&&(this._subscribe=t)}return t.prototype.lift=function(e){var n=new t;return n.source=this,n.operator=e,n},t.prototype.subscribe=function(t,e,n){var r=this.operator,o=H(t,e,n);if(r?r.call(o,this.source):o.add(this.source||!o.syncErrorThrowable?this._subscribe(o):this._trySubscribe(o)),Ie.useDeprecatedSynchronousErrorHandling&&o.syncErrorThrowable&&(o.syncErrorThrowable=!1,o.syncErrorThrown))throw o.syncErrorValue;return o},t.prototype._trySubscribe=function(t){try{return this._subscribe(t)}catch(e){Ie.useDeprecatedSynchronousErrorHandling&&(t.syncErrorThrown=!0,t.syncErrorValue=e),t.error(e)}},t.prototype.forEach=function(t,e){var n=this;return new(e=X(e))(function(e,r){var o;o=n.subscribe(function(e){try{t(e)}catch(t){r(t),o&&o.unsubscribe()}},r,e)})},t.prototype._subscribe=function(t){var e=this.source;return e&&e.subscribe(t)},t.prototype[He]=function(){return this},t.prototype.pipe=function(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return 0===t.length?this:G(t)(this)},t.prototype.toPromise=function(t){var e=this;return new(t=X(t))(function(t,n){var r;e.subscribe(function(t){return r=t},function(t){return n(t)},function(){return t(r)})})},t.create=function(e){return new t(e)},t}(),Ge=(Error,function(t){function e(e){var n=t.call(this,e)||this;return n.destination=e,n}return q(e,t),e}(Re)),Xe=function(){function t(t){this.connectable=t}return t.prototype.call=function(t,e){var n=this.connectable;n._refCount++;var r=new Ye(t,n),o=e.subscribe(r);return r.closed||(r.connection=n.connect()),o},t}(),Ye=function(t){function e(e,n){var r=t.call(this,e)||this;return r.connectable=n,r}return q(e,t),e.prototype._unsubscribe=function(){var t=this.connectable;if(!t)return void(this.connection=null);this.connectable=null;var e=t._refCount;if(e<=0)return void(this.connection=null);if(t._refCount=e-1,e>1)return void(this.connection=null);var n=this.connection,r=t._connection;this.connection=null,!r||n&&r!==n||r.unsubscribe()},e}(Re),Ve=function(t){function e(e,n){var r=t.call(this)||this;return r.source=e,r.subjectFactory=n,r._refCount=0,r._isComplete=!1,r}return q(e,t),e.prototype._subscribe=function(t){return this.getSubject().subscribe(t)},e.prototype.getSubject=function(){var t=this._subject;return t&&!t.isStopped||(this._subject=this.subjectFactory()),this._subject},e.prototype.connect=function(){var t=this._connection;return t||(this._isComplete=!1,t=this._connection=new Le,t.add(this.source.subscribe(new Be(this.getSubject(),this))),t.closed?(this._connection=null,t=Le.EMPTY):this._connection=t),t},e.prototype.refCount=function(){return Y()(this)},e}(ze),We=Ve.prototype,Be=(We._subscribe,We._isComplete,We.getSubject,We.connect,We.refCount,function(t){function e(e,n){var r=t.call(this,e)||this;return r.connectable=n,r}return q(e,t),e.prototype._error=function(e){this._unsubscribe(),t.prototype._error.call(this,e)},e.prototype._complete=function(){this.connectable._isComplete=!0,this._unsubscribe(),t.prototype._complete.call(this)},e.prototype._unsubscribe=function(){var t=this.connectable;if(t){this.connectable=null;var e=t._connection;t._refCount=0,t._subject=null,t._connection=null,e&&e.unsubscribe()}},e}(Ge)),Je=function(t){function e(e,n){return t.call(this)||this}return q(e,t),e.prototype.schedule=function(t,e){return void 0===e&&(e=0),this},e}(Le),$e=function(t){function e(e,n){var r=t.call(this,e,n)||this;return r.scheduler=e,r.work=n,r.pending=!1,r}return q(e,t),e.prototype.schedule=function(t,e){if(void 0===e&&(e=0),this.closed)return this;this.state=t;var n=this.id,r=this.scheduler;return null!=n&&(this.id=this.recycleAsyncId(r,n,e)),this.pending=!0,this.delay=e,this.id=this.id||this.requestAsyncId(r,this.id,e),this},e.prototype.requestAsyncId=function(t,e,n){return void 0===n&&(n=0),setInterval(t.flush.bind(t,this),n)},e.prototype.recycleAsyncId=function(t,e,n){return void 0===n&&(n=0),null!==n&&this.delay===n&&!1===this.pending?e:clearInterval(e)&&void 0||void 0},e.prototype.execute=function(t,e){if(this.closed)return new Error("executing a cancelled action");this.pending=!1;var n=this._execute(t,e);if(n)return n;!1===this.pending&&null!=this.id&&(this.id=this.recycleAsyncId(this.scheduler,this.id,null))},e.prototype._execute=function(t,e){var n=!1,r=void 0;try{this.work(t)}catch(t){n=!0,r=!!t&&t||new Error(t)}if(n)return this.unsubscribe(),r},e.prototype._unsubscribe=function(){var t=this.id,e=this.scheduler,n=e.actions,r=n.indexOf(this);this.work=null,this.state=null,this.pending=!1,this.scheduler=null,-1!==r&&n.splice(r,1),null!=t&&(this.id=this.recycleAsyncId(e,t,null)),this.delay=null},e}(Je),Ke=function(){function t(e,n){void 0===n&&(n=t.now),this.SchedulerAction=e,this.now=n}return t.prototype.schedule=function(t,e,n){return void 0===e&&(e=0),new this.SchedulerAction(this,t).schedule(n,e)},t.now=Date.now?Date.now:function(){return+new Date},t}(),Qe=function(t){function e(n,r){void 0===r&&(r=Ke.now);var o=t.call(this,n,function(){return e.delegate&&e.delegate!==o?e.delegate.now():r()})||this;return o.actions=[],o.active=!1,o.scheduled=void 0,o}return q(e,t),e.prototype.schedule=function(n,r,o){return void 0===r&&(r=0),e.delegate&&e.delegate!==this?e.delegate.schedule(n,r,o):t.prototype.schedule.call(this,n,r,o)},e.prototype.flush=function(t){var e=this.actions;if(this.active)return void e.push(t);var n;this.active=!0;do{if(n=t.execute(t.state,t.delay))break}while(t=e.shift());if(this.active=!1,n){for(;t=e.shift();)t.unsubscribe();throw n}},e}(Ke),Ze=new ze(function(t){return t.complete()}),tn=function(t){return function(e){for(var n=0,r=t.length;n<r&&!e.closed;n++)e.next(t[n]);e.closed||e.complete()}},en=new Qe($e),nn=(Error,Error,Error,function(){function t(t,e){this.project=t,this.thisArg=e}return t.prototype.call=function(t,e){return e.subscribe(new rn(t,this.project,this.thisArg))},t}()),rn=function(t){function e(e,n,r){var o=t.call(this,e)||this;return o.project=n,o.count=0,o.thisArg=r||o,o}return q(e,t),e.prototype._next=function(t){var e;try{e=this.project.call(this.thisArg,t,this.count++)}catch(t){return void this.destination.error(t)}this.destination.next(e)},e}(Re),on=function(t){return function(e){return t.then(function(t){e.closed||(e.next(t),e.complete())},function(t){return e.error(t)}).then(null,D),e}},un=function(){return"function"===typeof Symbol&&Symbol.iterator?Symbol.iterator:"@@iterator"}(),sn=function(t){return function(e){for(var n=t[un]();;){var r=n.next();if(r.done){e.complete();break}if(e.next(r.value),e.closed)break}return"function"===typeof n.return&&e.add(function(){n.return&&n.return()}),e}},an=function(t){return function(e){var n=t[He]();if("function"!==typeof n.subscribe)throw new TypeError("Provided object does not correctly implement Symbol.observable");return n.subscribe(e)}},cn=function(t){return t&&"number"===typeof t.length&&"function"!==typeof t},fn=function(t){if(t instanceof ze)return function(e){return t._isScalar?(e.next(t.value),void e.complete()):t.subscribe(e)};if(cn(t))return tn(t);if($(t))return on(t);if(t&&"function"===typeof t[un])return sn(t);if(t&&"function"===typeof t[He])return an(t);var e=U(t)?"an invalid object":"'"+t+"'",n="You provided "+e+" where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.";throw new TypeError(n)},ln=(Object.prototype.toString,function(){function t(t,e,n){void 0===n&&(n=!1),this.accumulator=t,this.seed=e,this.hasSeed=n}return t.prototype.call=function(t,e){return e.subscribe(new pn(t,this.accumulator,this.seed,this.hasSeed))},t}()),pn=function(t){function e(e,n,r,o){var i=t.call(this,e)||this;return i.accumulator=n,i._seed=r,i.hasSeed=o,i.index=0,i}return q(e,t),Object.defineProperty(e.prototype,"seed",{get:function(){return this._seed},set:function(t){this.hasSeed=!0,this._seed=t},enumerable:!0,configurable:!0}),e.prototype._next=function(t){if(this.hasSeed)return this._tryNext(t);this.seed=t,this.destination.next(t)},e.prototype._tryNext=function(t){var e,n=this.index++;try{e=this.accumulator(this.seed,t,n)}catch(t){this.destination.error(t)}this.seed=e,this.destination.next(e)},e}(Re),hn=function(){function t(t,e){this.count=t,this.source=e}return t.prototype.call=function(t,e){return e.subscribe(new dn(t,this.count,this.source))},t}(),dn=function(t){function e(e,n,r){var o=t.call(this,e)||this;return o.count=n,o.source=r,o}return q(e,t),e.prototype.error=function(e){if(!this.isStopped){var n=this,r=n.source,o=n.count;if(0===o)return t.prototype.error.call(this,e);o>-1&&(this.count=o-1),r.subscribe(this._unsubscribeAndRecycle())}},e}(Re),yn=function(){function t(t,e){this.value=t,this.interval=e}return t}(),mn={GET_POLICY:"GetPolicy",UPLOAD_FILE:"UploadFile",CREATE_PENDING_ATTACHMENT:"CreatePendingAttachment"},bn=function(t){function e(t,n,r){ct(this,e);var o=ft(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,n));return o.type=r,o.status=t,o}return lt(e,t),e}(function(t){function e(){var e=Reflect.construct(t,Array.from(arguments));return Object.setPrototypeOf(e,Object.getPrototypeOf(this)),e}return e.prototype=Object.create(t.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t,e}(Error)),vn=bn,gn=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),wn=function(){function t(e,n,r,o,i,u,s){pt(this,t),this.objectName=e,this.attachmentName=n,this.policyData=r,this.fileType=o,this.retryAttempts=i,this.file=u,this.onProgress=s}return gn(t,[{key:"abort",value:function(){this.uploadProcessSubscription&&this.uploadProcessSubscription.unsubscribe(),this.uploadXhrRequest&&this.uploadXhrRequest.abort()}},{key:"prepareDataForUpload",value:function(){var t=this.policyData.policy.s3_policy,e=this.fileType,n=Math.floor(26*Math.random())+Date.now(),r=t.guid+t.client_uniq_id_prefix+n,o=t.key.replace(t.guid,r),i=new FormData;return i.append("acl",t.acl),i.append("AWSAccessKeyId",t.AWSAccessKeyId),i.append("success_action_status",t.success_action_status),i.append("key",o),i.append("policy",t.policy),i.append("signature",t.signature),i.append("content-type",e),i.append("file",this.file),{formData:i,s3Policy:t}}},{key:"uploadToS3",value:function(t){var e=this;return new Promise(function(n,r){var o=void 0;e.uploadProcessSubscription=ze.create(function(n){e.uploadXhrRequest=new XMLHttpRequest,e.uploadXhrRequest.upload.onprogress=function(t){return n.next(100*t.loaded/t.total)},e.uploadXhrRequest.onload=function(){e.uploadXhrRequest.status>=200&&e.uploadXhrRequest.status<300?(o=e.uploadXhrRequest.response,n.complete()):n.error(new vn(e.uploadXhrRequest.status,e.uploadXhrRequest.statusText,mn.UPLOAD_FILE))},e.uploadXhrRequest.onerror=function(){n.error(new vn(e.uploadXhrRequest.status,e.uploadXhrRequest.statusText,mn.UPLOAD_FILE))},e.uploadXhrRequest.open("POST",t.s3Policy.action_url),e.uploadXhrRequest.send(t.formData)}).pipe(at(),J(function(t){return{percentage:t.value,timeElapsed:t.interval}}),st(e.retryAttempts)).subscribe(e.onProgress,r,function(){return n(o)})})}},{key:"logUploadTime",value:function(t){Qt({label:this.objectName+".filerr."+this.attachmentName+".s3_direct_upload",timing:Date.now()-t})}},{key:"parseS3UploadedData",value:function(t){var e=document.createRange().createContextualFragment(t);return{key:e.querySelector("Key").firstChild.nodeValue,bucketName:e.querySelector("Bucket").firstChild.nodeValue}}},{key:"handleUploadLogic",value:function(){var t=this,e=this.prepareDataForUpload(),n=Date.now();return this.uploadToS3(e).then(function(e){return t.logUploadTime(n),t.parseS3UploadedData(e)})}}]),t}(),_n=wn,xn=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),Pn=function(){function t(e,n,r,o){ht(this,t),this.objectName=e,this.attachmentName=n,this.createPendingAttachmentIdUrl=r,this.s3ParsedData=o}return xn(t,[{key:"createPendingAttachment",value:function(){return he(this.createPendingAttachmentIdUrl,{method:"POST",body:JSON.stringify({file_path:this.s3ParsedData.key,bucket_name:this.s3ParsedData.bucketName})})}},{key:"logCreatePendingAttachmentTime",value:function(t){Qt({label:this.objectName+".filerr."+this.attachmentName+".pending_attachment_creation",timing:Date.now()-t})}},{key:"handleCreatePendingAttachmentIdLogic",value:function(){var t=this;if(!this.createPendingAttachmentIdUrl)return this.s3ParsedData;var e=Date.now();return this.createPendingAttachment().then(function(n){if(!n.ok)throw new vn(n.status,n.statusText,mn.CREATE_PENDING_ATTACHMENT);return t.logCreatePendingAttachmentTime(e),n.json()}).catch(function(t){throw new vn(t.code,t.message,mn.CREATE_PENDING_ATTACHMENT)}).then(function(e){return Object.assign(t.s3ParsedData,{pendingAttachmentId:e.pending_attachment_id})})}}]),t}(),Sn=Pn,On=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),jn=function(){function t(e,n,r,o,i,u){dt(this,t),this.objectName=e,this.attachmentName=n,this.getPolicyUrl=r,this.createPendingAttachmentIdUrl=o,this.file=i,this.policyHandler=u,this.handleCreatePendingAttachmentIdLogic=this.handleCreatePendingAttachmentIdLogic.bind(this)}return On(t,[{key:"abort",value:function(){this.uploadHandler&&this.uploadHandler.abort()}},{key:"upload",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){return{}},n=this,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){return{}},o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:5;this.handlePolicyLogic().then(function(t){var e=t.policyData,i=t.fileType;return n.handleUploadLogic(e,i,r,o)}).then(this.handleCreatePendingAttachmentIdLogic).then(t).catch(e)}},{key:"handlePolicyLogic",value:function(){return this.policyHandler.validatePolicy(this.file)}},{key:"handleUploadLogic",value:function(t,e,n,r){return this.uploadHandler=new _n(this.objectName,this.attachmentName,t,e,r,this.file,n),this.uploadHandler.handleUploadLogic()}},{key:"handleCreatePendingAttachmentIdLogic",value:function(t){return new Sn(this.objectName,this.attachmentName,this.createPendingAttachmentIdUrl,t).handleCreatePendingAttachmentIdLogic()}}]),t}(),En=jn,kn=function(t){function e(t,n){yt(this,e);var r=mt(this,(e.__proto__||Object.getPrototypeOf(e)).call(this,t));return r.info=n,r}return bt(e,t),e}(function(t){function e(){var e=Reflect.construct(t,Array.from(arguments));return Object.setPrototypeOf(e,Object.getPrototypeOf(this)),e}return e.prototype=Object.create(t.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t,e}(Error)),An=kn,Tn=n("GpYf"),Nn=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),In=function(){function t(e,n,r){gt(this,t),this.getPolicyUrl=e,this.objectName=n,this.attachmentName=r}return Nn(t,[{key:"validatePolicy",value:function(t){var e=this;return this.getPolicy().then(function(n){return e.appendFileType(n,t)}).then(function(n){var r=n.policyData,o=n.fileType;return e.fiverrPolicyValidation(r.policy.fiverr_policy,o,t),{policyData:r,fileType:o}})}},{key:"getPolicy",value:function(){var t=this,e=Date.now();return this.policyPromise||(this.policyPromise=he(this.getPolicyUrl,{method:"POST",body:JSON.stringify({object_name:this.objectName,attachment_name:this.attachmentName})}).then(function(n){if(!n.ok)throw new vn(n.status,n.statusText,mn.GET_POLICY);return t.logPolicyFetchTime(e),n.json()}).catch(function(t){throw new vn(t.code,t.message,mn.GET_POLICY)})),this.policyPromise}},{key:"logPolicyFetchTime",value:function(t){Qt({label:this.objectName+".filerr."+this.attachmentName+".s3_policy",timing:Date.now()-t})}},{key:"appendFileType",value:function(t,e){return vt(e).then(function(e){return{policyData:t,fileType:e}})}},{key:"fiverrPolicyValidation",value:function(t,e,n){!function(){if(t.supported_file_types&&t.supported_file_types.length&&-1===t.supported_file_types.indexOf(e))throw new An("Unsupported file type: "+e,"supported types are: "+t.supported_file_types);if(t.unsupported_file_types&&t.unsupported_file_types.length&&-1!==t.unsupported_file_types.indexOf(e))throw new An("Unsupported file type: "+e,"unsupported types are: "+t.unsupported_file_types)}(),function(){if(t.max_file_size&&t.max_file_size<n.size)throw new An("Unsupported file size: "+n.size,"supported size is: "+t.max_file_size)}()}}]),t}(),qn=In;n.d(e,"FilerrUploader",function(){return Dn}),n.d(e,"RemoteActionError",function(){return vn}),n.d(e,"PolicyValidationError",function(){return An});var Cn=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),Dn=function(){function t(e){wt(this,t),t.validateConstructor(e),this.objectName=e.objectName,this.attachmentName=e.attachmentName,this.getPolicyUrl=e.getPolicyUrl,this.createPendingAttachmentIdUrl=e.createPendingAttachmentIdUrl,this.policyHandler=new qn(this.getPolicyUrl,this.objectName,this.attachmentName)}return Cn(t,[{key:"upload",value:function(e){t.validateUpload(e);var n=e.file,r=e.onSuccess,o=e.onError,i=e.onProgress,u=e.retryAttempts,s=new En(this.objectName,this.attachmentName,this.getPolicyUrl,this.createPendingAttachmentIdUrl,n,this.policyHandler);return s.upload(r,o,i,u),s}}],[{key:"validateConstructor",value:function(t){var e=t.objectName,n=t.attachmentName,r=t.getPolicyUrl,o=t.createPendingAttachmentIdUrl,i="Some required fields were'nt provided: ";if(e||(i+=" objectName, "),n||(i+=" attachmentName, "),r||(i+=" getPolicyUrl, "),"Some required fields were'nt provided: "!==i)throw new Error(i.slice(0,i.length-2));if(i="should be of type: String","string"!==typeof e&&(i=" ,objectName "+i),"string"!==typeof n&&(i=" ,attachmentName "+i),"string"!==typeof r&&(i=" ,getPolicyUrl "+i),o&&"string"!==typeof o&&(i=" ,createPendingAttachmentIdUrl "+i),"should be of type: String"!==i)throw new TypeError(i.slice(2))}},{key:"validateUpload",value:function(t){var e=t.file,n=t.onSuccess,r=t.onError,o=t.onProgress,i=t.retryAttempts,u="Some required fields were'nt provided: ";if(e||(u+=" file, "),n||(u+=" onSuccess, "),"Some required fields were'nt provided: "!==u)throw new Error(u.slice(0,u.length-2));if(!(e instanceof File))throw new TypeError("file should be of type: File");if(u="should be of type: Function","function"!==typeof n&&(u=" ,onSuccess "+u),r&&"function"!==typeof r&&(u=" ,onError "+u),o&&"function"!==typeof o&&(u=" ,onProgress "+u),"should be of type: Function"!==u)throw new TypeError(u.slice(2));if(i&&!(i instanceof Number))throw new TypeError("retryAttempts should be of type: Number")}}]),t}()}})});
//# sourceMappingURL=index.cfcc6d9ebea87f3a9a89.js.map

/***/ }),

/***/ "eIBB":
/***/ (function(module, exports) {

module.exports = {"seller_card":{"badge_now":"NOW","contact_me":"Contact Me","custom_order":"Custom Order","member_since":"Member since","from":"From","num_reviews":{"one":"%{count} review","other":"%{count} reviews"},"oneliner":{"placeholder":"What's your story in one line?","error_oneliner_short":"Text is too short - must be at least 3 characters.","error_oneliner_long":"Text is too long - must be 70 characters or less.","error_oneliner_invalid":"Text must contain only letters, numbers and (,!:')."},"read_more_text":{"more":"+ See More","less":"- See Less"},"recent_delivery":"Recent Delivery","response_time":"Avg. Response Time","response_time_hours":{"one":"1 hour","other":"${count} hours"},"response_time_days":{"one":"1 day","other":"${count} days"},"out_of_office":"Out of Office","pro":{"tooltip_seller":"Pro sellers are pre-vetted and hand selected professionals, verified by Fiverr","verified_by":"Verified by Fiverr in"},"view_as_buyer":"Preview Public Mode","view_as_seller":"Edit Profile Mode"}}

/***/ }),

/***/ "h4G9":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_h4G9__;

/***/ }),

/***/ "huvo":
/***/ (function(module, exports, __webpack_require__) {

/**
 * cssfilter
 *
 * @author 老雷<leizongmin@gmail.com>
 */

var DEFAULT = __webpack_require__("/cOS");
var parseStyle = __webpack_require__("Uo+f");
var _ = __webpack_require__("jCb9");


/**
 * 返回值是否为空
 *
 * @param {Object} obj
 * @return {Boolean}
 */
function isNull (obj) {
  return (obj === undefined || obj === null);
}

/**
 * 浅拷贝对象
 *
 * @param {Object} obj
 * @return {Object}
 */
function shallowCopyObject (obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}

/**
 * 创建CSS过滤器
 *
 * @param {Object} options
 *   - {Object} whiteList
 *   - {Function} onAttr
 *   - {Function} onIgnoreAttr
 *   - {Function} safeAttrValue
 */
function FilterCSS (options) {
  options = shallowCopyObject(options || {});
  options.whiteList = options.whiteList || DEFAULT.whiteList;
  options.onAttr = options.onAttr || DEFAULT.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  this.options = options;
}

FilterCSS.prototype.process = function (css) {
  // 兼容各种奇葩输入
  css = css || '';
  css = css.toString();
  if (!css) return '';

  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr = options.onAttr;
  var onIgnoreAttr = options.onIgnoreAttr;
  var safeAttrValue = options.safeAttrValue;

  var retCSS = parseStyle(css, function (sourcePosition, position, name, value, source) {

    var check = whiteList[name];
    var isWhite = false;
    if (check === true) isWhite = check;
    else if (typeof check === 'function') isWhite = check(value);
    else if (check instanceof RegExp) isWhite = check.test(value);
    if (isWhite !== true) isWhite = false;

    // 如果过滤后 value 为空则直接忽略
    value = safeAttrValue(name, value);
    if (!value) return;

    var opts = {
      position: position,
      sourcePosition: sourcePosition,
      source: source,
      isWhite: isWhite
    };

    if (isWhite) {

      var ret = onAttr(name, value, opts);
      if (isNull(ret)) {
        return name + ':' + value;
      } else {
        return ret;
      }

    } else {

      var ret = onIgnoreAttr(name, value, opts);
      if (!isNull(ret)) {
        return ret;
      }

    }
  });

  return retCSS;
};


module.exports = FilterCSS;


/***/ }),

/***/ "iCOP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "itU2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jCb9":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function (arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function (arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function (str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, '');
  },
  trimRight: function (str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, '');
  }
};


/***/ }),

/***/ "jPm4":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_jPm4__;

/***/ }),

/***/ "krhF":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Simple HTML Parser
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var _ = __webpack_require__("noAI");

/**
 * get tag name
 *
 * @param {String} html e.g. '<a hef="#">'
 * @return {String}
 */
function getTagName(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    var tagName = html.slice(1, -1);
  } else {
    var tagName = html.slice(1, i + 1);
  }
  tagName = _.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/") tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/") tagName = tagName.slice(0, -1);
  return tagName;
}

/**
 * is close tag?
 *
 * @param {String} html 如：'<a hef="#">'
 * @return {Boolean}
 */
function isClosing(html) {
  return html.slice(0, 2) === "</";
}

/**
 * parse input html and returns processed html
 *
 * @param {String} html
 * @param {Function} onTag e.g. function (sourcePosition, position, tag, html, isClosing)
 * @param {Function} escapeHtml
 * @return {String}
 */
function parseTag(html, onTag, escapeHtml) {
  "user strict";

  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";

  for (currentPos = 0; currentPos < len; currentPos++) {
    var c = html.charAt(currentPos);
    if (tagStart === false) {
      if (c === "<") {
        tagStart = currentPos;
        continue;
      }
    } else {
      if (quoteStart === false) {
        if (c === "<") {
          rethtml += escapeHtml(html.slice(lastPos, currentPos));
          tagStart = currentPos;
          lastPos = currentPos;
          continue;
        }
        if (c === ">") {
          rethtml += escapeHtml(html.slice(lastPos, tagStart));
          currentHtml = html.slice(tagStart, currentPos + 1);
          currentTagName = getTagName(currentHtml);
          rethtml += onTag(
            tagStart,
            rethtml.length,
            currentTagName,
            currentHtml,
            isClosing(currentHtml)
          );
          lastPos = currentPos + 1;
          tagStart = false;
          continue;
        }
        if ((c === '"' || c === "'") && html.charAt(currentPos - 1) === "=") {
          quoteStart = c;
          continue;
        }
      } else {
        if (c === quoteStart) {
          quoteStart = false;
          continue;
        }
      }
    }
  }
  if (lastPos < html.length) {
    rethtml += escapeHtml(html.substr(lastPos));
  }

  return rethtml;
}

var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9_:\.\-]/gim;

/**
 * parse input attributes and returns processed attributes
 *
 * @param {String} html e.g. `href="#" target="_blank"`
 * @param {Function} onAttr e.g. `function (name, value)`
 * @return {String}
 */
function parseAttr(html, onAttr) {
  "user strict";

  var lastPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;

  function addAttr(name, value) {
    name = _.trim(name);
    name = name.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name.length < 1) return;
    var ret = onAttr(name, value || "");
    if (ret) retAttrs.push(ret);
  }

  // 逐个分析字符
  for (var i = 0; i < len; i++) {
    var c = html.charAt(i);
    var v, j;
    if (tmpName === false && c === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      continue;
    }
    if (tmpName !== false) {
      if (
        i === lastPos &&
        (c === '"' || c === "'") &&
        html.charAt(i - 1) === "="
      ) {
        j = html.indexOf(c, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _.trim(html.slice(lastPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }

  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_.trim(html.slice(lastPos))));
    }
  }

  return _.trim(retAttrs.join(" "));
}

function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c = str[i];
    if (c === " ") continue;
    if (c === "=") return i;
    return -1;
  }
}

function isQuoteWrapString(text) {
  if (
    (text[0] === '"' && text[text.length - 1] === '"') ||
    (text[0] === "'" && text[text.length - 1] === "'")
  ) {
    return true;
  } else {
    return false;
  }
}

function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}

exports.parseTag = parseTag;
exports.parseAttr = parseAttr;


/***/ }),

/***/ "lVK7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React","var":"React"}
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__ = __webpack_require__("Jmof");
var external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__);

// EXTERNAL MODULE: external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"react-dom","root":"ReactDOM","var":"ReactDOM"}
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__ = __webpack_require__("wLXD");
var external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM__);

// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types","amd":"prop-types","root":"PropTypes","var":"PropTypes"}
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__ = __webpack_require__("T9WB");
var external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default = /*#__PURE__*/__webpack_require__.n(external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes__);

// EXTERNAL MODULE: ./src/components/status/style.scss
var style = __webpack_require__("I9N9");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// CONCATENATED MODULE: ./src/components/status/index.js




/**
 * @function
 * @name Status
 * @param {Boolean} isOnline - whether the user is online
 * @param {Integer} userId - the user's id
 * @param {Boolean} isOnVacation - whether the user is out of office
 * Returns the markup of the online indicator
 */

var status_Status = function Status(_ref) {
    var isOnline = _ref.isOnline,
        userId = _ref.userId,
        isOnVacation = _ref.isOnVacation;

    if (!isOnVacation) {
        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'span',
            { className: 'user-online-indicator ' + (isOnline ? 'is-online ' : ''), 'data-user-id': userId },
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-circle' }),
            i18n.t('general.online')
        );
    }

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'span',
        { className: 'user-ooo-indicator', 'data-user-id': userId },
        i18n.t('seller_card.out_of_office')
    );
};

status_Status.propTypes = {
    isOnVacation: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    isOnline: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool,
    userId: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.number
};

/* harmony default export */ var components_status = (status_Status);
// EXTERNAL MODULE: ./src/components/badges/style.scss
var badges_style = __webpack_require__("itU2");
var badges_style_default = /*#__PURE__*/__webpack_require__.n(badges_style);

// CONCATENATED MODULE: ./src/components/badges/index.js




/**
 * @function
 * @name Badges
 * @param {String} userName - the user's name
 * @param {Boolean} showAmbassador - should show the ambassador badge
 * @param {Boolean} showNow - should show the now badge
 * Returns the markup of the seller card badges
 */

var badges_Badges = function Badges(_ref) {
    var userName = _ref.userName,
        showAmbassador = _ref.showAmbassador,
        showNow = _ref.showNow;


    // now & ambassador badges take up the same space, so the now badge
    // takes precedence

    if (showNow) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'aside',
            { className: 'now-badge' },
            i18n.t('seller_card.badge_now'),
            ' ',
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'span',
                { className: 'beta-badge' },
                i18n.t('general.beta')
            )
        );
    } else if (showAmbassador) {

        return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'a',
            { href: 'https://www.fiverr.com/ambassadors/' + userName, className: 'ambassadors-badge' },
            i18n.t('general.ambassador')
        );
    }
};

badges_Badges.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    showAmbassador: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    showNow: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var badges = (badges_Badges);
// EXTERNAL MODULE: ./node_modules/@fiverr/filerr_uploader/dist/index.js
var dist = __webpack_require__("ZMEE");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./src/components/profile_image/style.scss
var profile_image_style = __webpack_require__("sfau");
var profile_image_style_default = /*#__PURE__*/__webpack_require__.n(profile_image_style);

// CONCATENATED MODULE: ./src/components/profile_image/index.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * @class
 * @name ProfileImage
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user profile image
 */

var profile_image_ProfileImage = function (_Component) {
    _inherits(ProfileImage, _Component);

    function ProfileImage(props) {
        _classCallCheck(this, ProfileImage);

        var _this = _possibleConstructorReturn(this, (ProfileImage.__proto__ || Object.getPrototypeOf(ProfileImage)).call(this, props));

        _this.state = {
            file: null,
            saving: false,
            newImage: ''
        };

        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.displayImage = _this.displayImage.bind(_this);
        return _this;
    }

    _createClass(ProfileImage, [{
        key: 'onInputChange',
        value: function onInputChange(e) {
            var _this2 = this;

            var file = e.target.files[0];

            if (!file) {
                return;
            }

            this.setState({
                file: file,
                saving: true
            }, function () {
                _this2.directUploadFile();
            });
        }
    }, {
        key: 'displayImage',
        value: function displayImage(fileUrl) {

            this.setState({
                file: null,
                saving: false,
                newImage: fileUrl
            });
        }
    }, {
        key: 'directUploadFile',
        value: function directUploadFile() {
            var _this3 = this;

            var saveImage = function saveImage(_ref) {
                var key = _ref.key,
                    bucketName = _ref.bucketName;

                var saveImageTime = Date.now();
                var formDataTemp = new FormData();
                formDataTemp.append('authenticity_token', _this3.props.authToken);
                formDataTemp.append('s3_file_path', key);
                formDataTemp.append('bucket_name', bucketName);

                return fetch('/profiles/update_photo', {
                    method: 'POST',
                    body: formDataTemp,
                    headers: new Headers({
                        'Accept': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-Token': _this3.props.authToken
                    }),
                    credentials: 'same-origin'
                }).then(function (response) {
                    return response.json();
                }).then(function (data) {

                    Fiverr._broadcastLogEvents({
                        facility: 'graphite',
                        type: 'timing',
                        label: 'profile.filerr.seller_page.update_photo',
                        value: Date.now() - saveImageTime
                    });

                    return data;
                }).catch(function (err) {

                    Fiverr._logEventToGraphite({
                        label: 'profile.filerr.seller_page.ajax.s3_upload.error',
                        percentage: 100
                    });

                    Fiverr._logErrorToServer('seller_card_package', 'Seller Filerr photo', '[s3_direct_upload] ' + err.responseText + ', status:' + err.status);
                });
            };

            var filerrUploaderOptions = {
                objectName: 'profile',
                attachmentName: 'photo',
                getPolicyUrl: '/attachments/policy'
            };

            var uploadOptions = {
                file: this.state.file,
                onSuccess: function onSuccess(s3UploadedData) {
                    saveImage(s3UploadedData).then(function (savedImageData) {
                        _this3.displayImage(savedImageData.url);
                    });
                },
                onError: function onError(err) {
                    if (err instanceof dist["PolicyValidationError"]) {
                        _this3.setState({
                            file: null,
                            saving: false,
                            newImage: ''
                        });
                    }
                }
            };

            var filerrUploader = new dist["FilerrUploader"](filerrUploaderOptions);
            filerrUploader.upload(uploadOptions);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing;


            var showUserBadge = user.is_seller && user.achievement && user.achievement > 0,
                badgeClasses = [{ rating: 0, class: 'no_level_seller' }, { rating: 1, class: 'level_one_seller' }, { rating: 2, class: 'level_two_seller' }, { rating: 5, class: 'top_rated_seller' }],
                badgeClass = showUserBadge ? badgeClasses.find(function (b) {
                return b.rating === user.achievement;
            }).class : '',
                newImage = this.state.newImage,
                hasImage = user.has_profile_photo || newImage,
                userNameLetter = user.username ? user.username.substring(0, 1) : 'x';

            var userImage = void 0,
                labelClass = '';

            if (allowEditing && !this.state.saving) {
                labelClass = 'editable';
            } else if (this.state.saving) {
                labelClass = 'loading';
            }

            if (hasImage) {
                userImage = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('img', { src: newImage ? newImage : user.profile_photo, className: 'user-pict-img', alt: user.username, width: '150', height: '150' });
            } else {
                userImage = external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'span',
                    { className: 'missing-image-user' },
                    userNameLetter
                );
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'label',
                { className: 'user-pict-150 ' + labelClass, htmlFor: 'profile_image' },
                allowEditing && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { accept: 'image/png,image/jpeg', className: 'hidden', onChange: this.onInputChange, id: 'profile_image', name: 'profile[image]', type: 'file' }),
                userImage,
                showUserBadge && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('a', { href: '/levels', className: 'user-badge-round-med ' + badgeClass })
            );
        }
    }]);

    return ProfileImage;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

profile_image_ProfileImage.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    authToken: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
};

/* harmony default export */ var profile_image = (profile_image_ProfileImage);
// EXTERNAL MODULE: ./src/components/profile_link/style.scss
var profile_link_style = __webpack_require__("I3Iz");
var profile_link_style_default = /*#__PURE__*/__webpack_require__.n(profile_link_style);

// CONCATENATED MODULE: ./src/components/profile_link/index.js




var profile_link_RenderName = function RenderName(_ref) {
    var userName = _ref.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'b',
        { className: 'seller-link' },
        userName
    );
};

var profile_link_RenderNameWithLink = function RenderNameWithLink(_ref2) {
    var userName = _ref2.userName;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'a',
        { href: '/' + userName, className: 'seller-link', rel: 'nofollow,noindex' },
        userName
    );
};

/**
 * @function
 * @name ProfileLink
 * @param {String} userName - the user's name
 * @param {Boolean} noLink - text only, don't make it a link
 * Returns the markup of the user profile link
 */

var profile_link_ProfileLink = function ProfileLink(_ref3) {
    var userName = _ref3.userName,
        noLink = _ref3.noLink;
    return noLink ? external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link_RenderName, { userName: userName }) : external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link_RenderNameWithLink, { userName: userName });
};

profile_link_ProfileLink.propTypes = {
    userName: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string,
    noLink: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool
};

/* harmony default export */ var profile_link = (profile_link_ProfileLink);
// CONCATENATED MODULE: ./src/utils.js
/**
 * @name hasOneliner
 * @param {String} oneLiner - seller's oneliner text
 * @return {Boolean} Does this seller have a valid oneliner text?
 */
function hasOneliner(oneLiner) {
    return oneLiner && oneLiner.length > 0 && oneLiner !== i18n.t('seller_card.oneliner.placeholder');
}

/**
 * @name showResponseTime
 * @param {String} sellerResponsiveness - seller's responsive time
 * @return {Boolean} Does this seller have a valid responsive time?
 */
function showResponseTime(sellerResponsiveness) {
    return parseInt(sellerResponsiveness, 10) > 0;
}

/**
 * @name formatHoursAsDays
 * @param {Integer} hours - the hours that should be formatted
 * @return {String} A translated string with either hours or days
 */
function formatHoursAsDays(hours) {

    var output = void 0;

    if (hours < 24) {
        output = i18n.t('seller_card.response_time_hours', { count: hours });
    } else {
        var days = Math.round(hours / 24);
        output = i18n.t('seller_card.response_time_days', { count: days });
    }

    return output;
}

/**
 * Replace break tags with something else
 * @param  {String} string
 * @param  {String} [replacer='\r\n']
 * @return {String}
 */
var replaceBreakTags = function replaceBreakTags(string) {
    var replacer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '\r\n';
    return string.replace(/\s?(<br\s?\/?>)\s?/g, replacer);
}; // eslint-disable-line no-control-regex
// EXTERNAL MODULE: ./src/components/oneliner/style.scss
var oneliner_style = __webpack_require__("1fVw");
var oneliner_style_default = /*#__PURE__*/__webpack_require__.n(oneliner_style);

// CONCATENATED MODULE: ./src/components/oneliner/index.js
var oneliner__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function oneliner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function oneliner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function oneliner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * @class
 * @name Oneliner
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {String} authToken - Fiverr authentication token
 * Returns the markup of the user oneliner & ratings
 */

var oneliner_Oneliner = function (_Component) {
    oneliner__inherits(Oneliner, _Component);

    function Oneliner(props) {
        oneliner__classCallCheck(this, Oneliner);

        var _this = oneliner__possibleConstructorReturn(this, (Oneliner.__proto__ || Object.getPrototypeOf(Oneliner)).call(this, props));

        _this.state = {
            mode: 'view', // view, edit, error
            oneliner: '',
            initialOneliner: '',
            errorText: ''
        };

        _this.onEditIconClick = _this.onEditIconClick.bind(_this);
        _this.onSaveClick = _this.onSaveClick.bind(_this);
        _this.onCancelClick = _this.onCancelClick.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onInputKeyPress = _this.onInputKeyPress.bind(_this);
        return _this;
    }

    oneliner__createClass(Oneliner, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var onelinerText = '';

            if (hasOneliner(this.props.user.one_liner)) {
                onelinerText = this.props.user.one_liner;
            } else if (this.props.allowEditing) {
                onelinerText = i18n.t('seller_card.oneliner.placeholder');
            }

            this.setState({
                oneliner: onelinerText,
                initialOneliner: onelinerText
            });
        }
    }, {
        key: 'onEditIconClick',
        value: function onEditIconClick() {
            this.setState({
                mode: 'edit'
            });
        }
    }, {
        key: 'onSaveClick',
        value: function onSaveClick(e) {
            e.preventDefault();

            var check = this.checkForValid();
            if (check.isValid) {

                if (typeof fetch !== 'undefined' && this.state.oneliner !== this.state.initialOneliner) {

                    fetch('/users/' + this.props.user.username, {
                        method: 'PATCH',
                        body: encodeURI('user[profile_attributes][one_liner]=' + this.state.oneliner),
                        headers: new Headers({
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRF-Token': this.props.authToken
                        }),
                        credentials: 'same-origin'
                    }).catch(function (err) {
                        console.log('There was an error when trying to update the oneliner: ', err.message); // eslint-disable-line
                    });
                }

                this.setState({
                    mode: 'view',
                    initialOneliner: this.state.oneliner,
                    errorText: ''
                });
            } else {

                this.setState({
                    mode: 'error',
                    errorText: check.errorText
                });
            }
        }
    }, {
        key: 'onCancelClick',
        value: function onCancelClick(e) {
            e.preventDefault();
            this.setState({
                mode: 'view',
                oneliner: this.state.initialOneliner,
                errorText: ''
            });
        }
    }, {
        key: 'onInputChange',
        value: function onInputChange(e) {
            this.setState({
                oneliner: e.target.value,
                errorText: ''
            });
        }
    }, {
        key: 'onInputKeyPress',
        value: function onInputKeyPress(e) {
            if (e.key === 'Enter') {
                this.onSaveClick(e);
            }
        }
    }, {
        key: 'checkForValid',
        value: function checkForValid() {

            var value = this.state.oneliner;

            var isValid = true,
                errorText = '';

            // validate oneliner
            if (value === '' || value.length < 3) {
                // blank text, text too short
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_short');
            } else if (value.length > 70) {
                // text too long
                isValid = false;
                errorText = i18n.t('seller_card.oneliner.error_oneliner_long');
            } else if (value === this.state.initialOneliner) {
                // text hasn't changed, do nothing
            } else if (value.trim() === i18n.t('seller_card.oneliner.placeholder')) {
                // text is the default placeholder, do nothing
            } else {
                if (/^[a-zA-Z0-9\s\,\?\:\'\"\!]+$/.test(value)) {// eslint-disable-line
                    // text has changed & is valid
                } else {
                    // text has changed, but is invalid
                    isValid = false;
                    errorText = i18n.t('seller_card.oneliner.error_oneliner_invalid');
                }
            }

            return {
                isValid: isValid,
                errorText: errorText
            };
        }
    }, {
        key: 'renderEditIcon',
        value: function renderEditIcon() {
            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('i', { className: 'fa fa-pencil icn-edit', onClick: this.onEditIconClick });
        }
    }, {
        key: 'renderEditForm',
        value: function renderEditForm() {
            var _this2 = this;

            var showError = this.state.mode === 'error' && this.state.errorText !== '';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'form',
                null,
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'text', name: 'user[profile_attributes][one_liner]', autoFocus: 'autofocus', maxLength: '70', ref: function ref(inp) {
                        return inp && inp.focus();
                    }, value: this.state.oneliner, autoComplete: 'off', onChange: function onChange(e) {
                        return _this2.onInputChange(e);
                    }, onKeyPress: function onKeyPress(e) {
                        return _this2.onInputKeyPress(e);
                    } }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard btn-white m-r-20', onClick: this.onCancelClick },
                    i18n.t('general.cancel')
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'button',
                    { className: 'btn-lrg-standard', onClick: this.onSaveClick },
                    i18n.t('general.update')
                ),
                showError && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'error-container' },
                    this.state.errorText
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing;


            var showOneliner = hasOneliner(user.one_liner) || allowEditing,
                userRatingsCount = parseInt(user.ratings_count, 10),
                showRating = user.is_seller && user.ratings_count > 0,
                showError = this.state.mode === 'error' && this.state.errorText !== '',
                showEdit = this.state.mode === 'edit' || this.state.mode === 'error';

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'oneliner-wrapper' + (showEdit ? ' edit-mode' : '') + (showError ? ' error-mode' : '') + (!showRating ? ' no-rating' : '') },
                showOneliner && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'small',
                    { className: 'oneliner' },
                    this.state.oneliner
                ),
                allowEditing && this.renderEditIcon(),
                showEdit && this.renderEditForm(),
                showRating && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'div',
                    { className: 'ratings-wrapper' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('span', { className: 'star-rating-s15 rate-' + Math.round(user.rating * 2), 'data-user-rating': user.rating, 'data-user-ratings-count': user.ratings_count }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'p',
                        { className: 'rating-text' },
                        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                            'strong',
                            null,
                            user.rating.toFixed(1)
                        ),
                        ' ',
                        '(' + i18n.t('seller_card.num_reviews', { count: userRatingsCount < 1000 ? userRatingsCount : '1k+' }) + ')'
                    )
                )
            );
        }
    }]);

    return Oneliner;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

oneliner_Oneliner.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    authToken: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string.isRequired
};

/* harmony default export */ var oneliner = (oneliner_Oneliner);
// EXTERNAL MODULE: ./src/components/buttons/style.scss
var buttons_style = __webpack_require__("Bdlu");
var buttons_style_default = /*#__PURE__*/__webpack_require__.n(buttons_style);

// CONCATENATED MODULE: ./src/components/buttons/index.js
var buttons__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function buttons__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function buttons__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function buttons__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var VIEW_AS_BUYER_QUERY = 'view_as_buyer',
    VIEW_AS_SELLER_QUERY = 'view_as_seller';

/**
 * @class
 * @name Buttons
 * @extends Component
 * @param {Object} user - all the user data
 * @param {Boolean} isMobileResponsive - mobile responsive or not
 * @param {Boolean} allowEditing - whether the user can edit
 * @param {Boolean} viewingAsBuyer - whether the seller is viewing their page as a buyer
 * @param {Boolean} isCurrentUser - whether the user is currently logged in
 * @param {Boolean} showCustomOrder - whether we should show the custom order button (if applicable)
 * Container for rendering markup of the contact/custom order buttons
 */

var buttons_Buttons = function (_Component) {
    buttons__inherits(Buttons, _Component);

    function Buttons(props) {
        buttons__classCallCheck(this, Buttons);

        var _this = buttons__possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).call(this, props));

        _this.onContactClick = _this.onContactClick.bind(_this);
        _this.onViewAsClick = _this.onViewAsClick.bind(_this);
        return _this;
    }

    buttons__createClass(Buttons, [{
        key: 'onContactClick',
        value: function onContactClick() {
            // NOTE: MixpanelWrapper is instantiated in v2
            if (typeof MixpanelWrapper !== 'undefined') {
                MixpanelWrapper.bindLink(this.contactBtn, MixpanelWrapper.Events.ConversationEvents.CLICKED_CONTACT_ME);
            }
        }
    }, {
        key: 'onViewAsClick',
        value: function onViewAsClick(e) {
            e.preventDefault();
            var viewingAsBuyer = this.props.viewingAsBuyer;

            var queryType = viewingAsBuyer ? VIEW_AS_BUYER_QUERY : VIEW_AS_SELLER_QUERY,
                cleanLocation = window.location.href.split(/[?#]/)[0];
            window.location.href = cleanLocation + '?' + queryType + '=true';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                user = _props.user,
                isMobileResponsive = _props.isMobileResponsive,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isCurrentUser = _props.isCurrentUser,
                showCustomOrder = _props.showCustomOrder,
                inWhitingContactButton = _props.inWhitingContactButton;


            var contactCls = void 0,
                contactSingle = false,
                orderCls = void 0,
                showContact = user.live_gigs && user.live_gigs.length > 0 && (!user.is_on_vacation || user.is_on_vacation && user.allow_contact),
                showCustomOrderValid = showCustomOrder && user.is_seller && user.custom_orders_allowed && !allowEditing;

            // if user is viewing their own page in the seller view,
            // we don't show the "contact me"-button

            if (allowEditing && !viewingAsBuyer) {
                showContact = false;
            }

            var contactLink = user.contact_path || '/conversations/' + user.username,
                orderLink = '/custom_orders/request/' + user.username + '/new',
                showViewAs = !isMobileResponsive && (allowEditing || viewingAsBuyer),
                viewAsString = i18n.t('seller_card.view_as_' + (viewingAsBuyer ? 'seller' : 'buyer'));

            if (user.is_spotlight) {
                showContact = false;
                showCustomOrderValid = false;
            }

            // if no buttons are shown, don't return the wrapper
            if (!showContact && !showCustomOrderValid && !showViewAs) {
                return null;
            }

            // if contact button is the only one shown, give it a special class
            if (showContact && !showCustomOrderValid && !showViewAs) {
                contactSingle = true;
            }

            if (isMobileResponsive) {

                contactCls = 'btn-standard btn-contact-me btn-green-grad m-b-15 fs-14';
                orderCls = 'btn-standard btn-custom-order m-b-15';
            } else {

                // TODO: "js-contact-me" is referenced in v2 (inside "popup-first-message.js"), needs to be updated
                // NOTE: "js-open-popup-login", "js-open-popup-join", "js-request-custom-order-button" are all bound to v2 JS functions
                contactCls = 'btn-lrg-standard btn-contact-me ' + (inWhitingContactButton ? 'btn-white' : '') + ' js-contact-me ' + (!isCurrentUser ? 'js-open-popup-login' : '') + ' ' + (contactSingle ? 'single-button' : '');
                orderCls = 'btn-lrg-standard btn-white btn-custom-order ' + (isCurrentUser ? 'js-request-custom-order-button' : 'js-open-popup-join');
            }

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'buttons-wrapper' },
                showContact && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: contactLink, className: contactCls, onClick: this.onContactClick, ref: function ref(ele) {
                            _this2.contactBtn = ele;
                        }, rel: 'nofollow', 'data-user-id': user.username, 'data-redirect-url': contactLink },
                    i18n.t('seller_card.contact_me')
                ),
                showCustomOrderValid && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: orderLink, className: orderCls },
                    i18n.t('seller_card.custom_order')
                ),
                showViewAs && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'a',
                    { href: '#!', className: 'btn-lrg-standard btn-white btn-view-as', onClick: this.onViewAsClick },
                    viewAsString
                ),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('div', { id: 'react-first-message-popup' })
            );
        }
    }]);

    return Buttons;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

buttons_Buttons.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    isMobileResponsive: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    viewingAsBuyer: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    isCurrentUser: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    showCustomOrder: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var buttons = (buttons_Buttons);
// EXTERNAL MODULE: ./src/components/pro/style.scss
var pro_style = __webpack_require__("3XGG");
var pro_style_default = /*#__PURE__*/__webpack_require__.n(pro_style);

// CONCATENATED MODULE: ./src/components/pro/index.js




/**
 * @function
 * @name Pro
 * @param {Object} proCategories - the user's pro subcategories
 * Returns the markup of the user pro subcategories
 */

var pro_Pro = function Pro(_ref) {
    var proCategories = _ref.proCategories;
    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'div',
        { className: 'pro-wrapper' },
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'p',
            null,
            i18n.t('seller_card.pro.verified_by')
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'label',
            { className: 'pro-badge hint--left', 'data-hint': i18n.t('seller_card.pro.tooltip_seller') },
            i18n.t('general.pro')
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'ul',
            null,
            proCategories.map(function (subcategory, index) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'li',
                    { key: index },
                    subcategory.name
                );
            })
        )
    );
};

pro_Pro.propTypes = {
    proCategories: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.array
};

/* harmony default export */ var pro = (pro_Pro);
// EXTERNAL MODULE: ./src/components/stats/style.scss
var stats_style = __webpack_require__("RIUQ");
var stats_style_default = /*#__PURE__*/__webpack_require__.n(stats_style);

// CONCATENATED MODULE: ./src/components/stats/index.js





/**
 * @function
 * @name Stats
 * @param {Object} user - all the user data
 * @param {Boolean} allowEditing - whether the user can edit
 * Returns the markup of the seller stats
 */
var stats_Stats = function Stats(_ref) {
    var user = _ref.user,
        allowEditing = _ref.allowEditing,
        toggleVacation = _ref.toggleVacation,
        isOnVacation = _ref.isOnVacation;

    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    var showCountry = user.country && user.country.length > 0,


    // showLastDelivery = parseInt(user.recent_delivery, 10) > 0, // this is the correct way
    showLastDelivery = user.recent_delivery && user.recent_delivery.length > 0,
        // this is getting the wrong value from v2
    memberSinceDate = new Date(user.member_since * 1000),
        memberSince = monthNames[memberSinceDate.getMonth()] + ' ' + memberSinceDate.getFullYear();

    return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
        'ul',
        { className: 'user-stats' },
        showCountry && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'location' },
            i18n.t('seller_card.from'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                user.country
            )
        ),
        external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'member-since' },
            i18n.t('seller_card.member_since'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                memberSince
            )
        ),
        showResponseTime(user.response_time) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'response-time' },
            i18n.t('seller_card.response_time'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                formatHoursAsDays(user.response_time)
            )
        ),
        showLastDelivery && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'recent-delivery' },
            i18n.t('seller_card.recent_delivery'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'strong',
                null,
                user.recent_delivery
            )
        ),
        allowEditing && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
            'li',
            { className: 'vacation' },
            i18n.t('seller_card.out_of_office'),
            external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'toggle-wrapper rf' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'label',
                    { onClick: toggleVacation, className: 'toggle-vacation' },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('input', { type: 'checkbox', value: 'vacation', className: isOnVacation ? 'sel' : '', checked: isOnVacation }),
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement('div', { className: 'fake-toggle' })
                )
            )
        )
    );
};

stats_Stats.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired
};

/* harmony default export */ var stats = (stats_Stats);
// EXTERNAL MODULE: ./src/components/description/style.scss
var description_style = __webpack_require__("R5aA");
var description_style_default = /*#__PURE__*/__webpack_require__.n(description_style);

// CONCATENATED MODULE: ./src/components/description/index.js
var description__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function description__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function description__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function description__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var xss = __webpack_require__("NG4M");

/**
 * @class
 * @name Description
 * @extends Component
 * @param {String} userDescription - the seller's description
 * Container for rendering markup of the seller description
 */

var description_Description = function (_Component) {
    description__inherits(Description, _Component);

    function Description(props) {
        description__classCallCheck(this, Description);

        var _this = description__possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));

        _this.onReadMoreClick = _this.onReadMoreClick.bind(_this);

        _this.state = {
            descExpanded: false
        };
        return _this;
    }

    description__createClass(Description, [{
        key: 'onReadMoreClick',
        value: function onReadMoreClick(e) {
            e.preventDefault();

            this.setState({
                descExpanded: !this.state.descExpanded
            });
        }
    }, {
        key: 'render',
        value: function render() {

            var desc = '';

            try {
                desc = xss(replaceBreakTags(this.props.userDescription), {
                    whiteList: [],
                    stripIgnoreTag: true,
                    stripIgnoreTagBody: ['script', 'a']
                });
            } catch (error) {
                // fail silently
            }

            var showReadMore = desc.length > 120;

            // if we stripped all tags, the description might now be empty
            if (desc.length > 0) {
                return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                    'footer',
                    { className: 'seller-desc ' + (this.state.descExpanded || !showReadMore ? 'expanded' : '') },
                    external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'div',
                        { className: 'inner' },
                        desc
                    ),
                    showReadMore && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                        'a',
                        { href: '#!', className: 'read-more', onClick: this.onReadMoreClick },
                        i18n.t('seller_card.read_more_text.' + (this.state.descExpanded ? 'less' : 'more'))
                    )
                );
            } else {
                return false;
            }
        }
    }]);

    return Description;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["Component"]);

description_Description.propTypes = {
    userDescription: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

/* harmony default export */ var description = (description_Description);
// EXTERNAL MODULE: ./src/translations.en.json
var translations_en = __webpack_require__("eIBB");
var translations_en_default = /*#__PURE__*/__webpack_require__.n(translations_en);

// EXTERNAL MODULE: external "@fiverr/globals"
var globals_ = __webpack_require__("E4I8");
var globals__default = /*#__PURE__*/__webpack_require__.n(globals_);

// EXTERNAL MODULE: ./src/index.scss
var src = __webpack_require__("iCOP");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./src/SellerCard.js
var SellerCard__createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function SellerCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function SellerCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function SellerCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var SellerCard_SellerCard = function (_PureComponent) {
    SellerCard__inherits(SellerCard, _PureComponent);

    function SellerCard(props) {
        SellerCard__classCallCheck(this, SellerCard);

        var _this = SellerCard__possibleConstructorReturn(this, (SellerCard.__proto__ || Object.getPrototypeOf(SellerCard)).call(this, props));

        i18n.add(translations_en_default.a);

        _this.state = {
            isOnline: false,
            isOnVacation: props.user.is_on_vacation
        };

        _this.toggleVacation = _this.toggleVacation.bind(_this);
        return _this;
    }

    SellerCard__createClass(SellerCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (document) {
                document.addEventListener('popup_close', function () {
                    _this2.setState({
                        isOnVacation: false
                    });
                });

                document.addEventListener('out_of_office_on', function () {
                    _this2.setState({
                        isOnVacation: true
                    });
                });
            }

            var user = this.props.user;

            // this has a lot of checking to ensure this fails silently
            // when running in static or dev mode

            gofor('/users/' + user.username + '/is_online', {
                method: 'GET'
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response) {
                    _this2.setState({
                        isOnline: response.is_online === true
                    });
                }
            }).catch(function (err) {
                throw err;
            });
        }
    }, {
        key: 'toggleVacation',
        value: function toggleVacation(e) {
            var _this3 = this;

            e.preventDefault();
            e.stopPropagation();

            var user = this.props.user;


            if (this.state.isOnVacation) {
                gofor('/users/' + user.username + '/vacations', {
                    method: 'delete'
                }).then(function (response) {
                    if (response) {
                        var event = new CustomEvent('open_popup', { detail: false });
                        document.dispatchEvent(event);
                        _this3.setState({
                            isOnVacation: false
                        });
                    }
                }).catch(function (err) {
                    throw err;
                });
            } else {
                var event = new CustomEvent('open_popup', { detail: true });
                document.dispatchEvent(event);
                this.setState({
                    isOnVacation: true
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isOnline = _state.isOnline,
                isOnVacation = _state.isOnVacation;
            var _props = this.props,
                user = _props.user,
                allowEditing = _props.allowEditing,
                viewingAsBuyer = _props.viewingAsBuyer,
                isMobileResponsive = _props.isMobileResponsive,
                currentUser = _props.currentUser,
                showDescription = _props.showDescription,
                showCustomOrder = _props.showCustomOrder,
                authToken = _props.authToken,
                inWhitingContactButton = _props.inWhitingContactButton;


            var isCurrentUser = currentUser ? true : false,
                // eslint-disable-line
            neverLinkName = !showDescription,
                // when we're showing the description, we want to link the username as well
            allowEditingReal = allowEditing && !viewingAsBuyer,
                // if the user is in "buyer preview"-mode, editing is disabled
            showAmbassador = user.is_ambassador,
                showNow = user.is_now_seller,
                showDescriptionReal = showDescription && user.description && user.description.length > 0,
                showPro = user.is_pro && user.pro_sub_categories && !!user.pro_sub_categories.length;

            return external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(
                'div',
                { className: 'user-main-info' },
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(components_status, { isOnline: isOnline, userId: user.id, isOnVacation: isOnVacation }),
                (showAmbassador || showNow) && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(badges, { userName: user.username, showAmbassador: showAmbassador, showNow: showNow }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_image, { user: user, allowEditing: allowEditingReal, authToken: authToken }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(profile_link, { userName: user.username, noLink: neverLinkName }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(oneliner, { user: user, allowEditing: allowEditingReal, authToken: authToken }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(buttons, { user: user, isMobileResponsive: isMobileResponsive, allowEditing: allowEditingReal, viewingAsBuyer: viewingAsBuyer, isCurrentUser: isCurrentUser, showCustomOrder: showCustomOrder, inWhitingContactButton: inWhitingContactButton }),
                showPro && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(pro, { proCategories: user.pro_sub_categories }),
                external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(stats, { user: user, allowEditing: allowEditingReal, isOnVacation: isOnVacation, toggleVacation: this.toggleVacation }),
                showDescriptionReal && external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(description, { userDescription: user.description })
            );
        }
    }]);

    return SellerCard;
}(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React__["PureComponent"]);

SellerCard_SellerCard.propTypes = {
    user: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    allowEditing: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    viewingAsBuyer: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    isMobileResponsive: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    currentUser: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.object.isRequired,
    showDescription: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    showCustomOrder: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.bool.isRequired,
    authToken: external___commonjs___prop_types___commonjs2___prop_types___amd___prop_types___root___PropTypes___var___PropTypes___default.a.string
};

SellerCard_SellerCard.defaultProps = {
    user: {},
    allowEditing: false,
    viewingAsBuyer: false,
    isMobileResponsive: false,
    currentUser: {},
    showDescription: true,
    showCustomOrder: true,
    authToken: ''
};

/* harmony default export */ var src_SellerCard = (SellerCard_SellerCard);
// CONCATENATED MODULE: ./src/index.js




var componentElm = typeof document !== 'undefined' && document.getElementById('SellerCard-component');

if (componentElm) {
    var initialState = window.initialData.SellerCard;

    external___commonjs___react_dom___commonjs2___react_dom___amd___react_dom___root___ReactDOM___var___ReactDOM___default.a.render(external___commonjs___react___commonjs2___react___amd___react___root___React___var___React___default.a.createElement(src_SellerCard, initialState), componentElm);
}

/* harmony default export */ var src_0 = __webpack_exports__["default"] = (src_SellerCard);

/***/ }),

/***/ "noAI":
/***/ (function(module, exports) {

module.exports = {
  indexOf: function(arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function(arr, fn, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn.call(scope, arr[i], i, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  }
};


/***/ }),

/***/ "oz9r":
/***/ (function(module, exports, __webpack_require__) {

/**
 * default settings
 *
 * @author Zongmin Lei<leizongmin@gmail.com>
 */

var FilterCSS = __webpack_require__("0Zbq").FilterCSS;
var getDefaultCSSWhiteList = __webpack_require__("0Zbq").getDefaultWhiteList;
var _ = __webpack_require__("noAI");

function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: ["autoplay", "controls", "loop", "preload", "src"],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height"],
    ins: ["datetime"],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: ["autoplay", "controls", "loop", "preload", "src", "height", "width"]
  };
}

var defaultCSSFilter = new FilterCSS();

/**
 * default onTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onTag(tag, html, options) {
  // do nothing
}

/**
 * default onIgnoreTag function
 *
 * @param {String} tag
 * @param {String} html
 * @param {Object} options
 * @return {String}
 */
function onIgnoreTag(tag, html, options) {
  // do nothing
}

/**
 * default onTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default onIgnoreTagAttr function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @return {String}
 */
function onIgnoreTagAttr(tag, name, value) {
  // do nothing
}

/**
 * default escapeHtml function
 *
 * @param {String} html
 */
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}

/**
 * default safeAttrValue function
 *
 * @param {String} tag
 * @param {String} name
 * @param {String} value
 * @param {Object} cssFilter
 * @return {String}
 */
function safeAttrValue(tag, name, value, cssFilter) {
  // unescape attribute value firstly
  value = friendlyAttrValue(value);

  if (name === "href" || name === "src") {
    // filter `href` and `src` attribute
    // only allow the value that starts with `http://` | `https://` | `mailto:` | `/` | `#`
    value = _.trim(value);
    if (value === "#") return "#";
    if (
      !(
        value.substr(0, 7) === "http://" ||
        value.substr(0, 8) === "https://" ||
        value.substr(0, 7) === "mailto:" ||
        value.substr(0, 4) === "tel:" ||
        value[0] === "#" ||
        value[0] === "/"
      )
    ) {
      return "";
    }
  } else if (name === "background") {
    // filter `background` attribute (maybe no use)
    // `javascript:`
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name === "style") {
    // `expression()`
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    // `url()`
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }

  // escape `<>"` before returns
  value = escapeAttrValue(value);
  return value;
}

// RegExp list
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
var REGEXP_DEFAULT_ON_TAG_ATTR_3 = /\/\*|\*\//gm;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_5 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_6 = /^[\s"'`]*(d\s*a\s*t\s*a\s*)\:\s*image\//gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;

/**
 * escape doube quote
 *
 * @param {String} str
 * @return {String} str
 */
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}

/**
 * unescape double quote
 *
 * @param {String} str
 * @return {String} str
 */
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}

/**
 * escape html entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str, code) {
    return code[0] === "x" || code[0] === "X"
      ? String.fromCharCode(parseInt(code.substr(1), 16))
      : String.fromCharCode(parseInt(code, 10));
  });
}

/**
 * escape html5 new danger entities
 *
 * @param {String} str
 * @return {String}
 */
function escapeDangerHtml5Entities(str) {
  return str
    .replace(REGEXP_ATTR_VALUE_COLON, ":")
    .replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}

/**
 * clear nonprintable characters
 *
 * @param {String} str
 * @return {String}
 */
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _.trim(str2);
}

/**
 * get friendly attribute value
 *
 * @param {String} str
 * @return {String}
 */
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}

/**
 * unescape attribute value
 *
 * @param {String} str
 * @return {String}
 */
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}

/**
 * `onIgnoreTag` function for removing all the tags that are not in whitelist
 */
function onIgnoreTagStripAll() {
  return "";
}

/**
 * remove tag body
 * specify a `tags` list, if the tag is not in the `tags` list then process by the specify function (optional)
 *
 * @param {array} tags
 * @param {function} next
 */
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function() {};
  }

  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag) return true;
    return _.indexOf(tags, tag) !== -1;
  }

  var removeList = [];
  var posStart = false;

  return {
    onIgnoreTag: function(tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function(html) {
      var rethtml = "";
      var lastPos = 0;
      _.forEach(removeList, function(pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    }
  };
}

/**
 * remove html comments
 *
 * @param {String} html
 * @return {String}
 */
function stripCommentTag(html) {
  return html.replace(STRIP_COMMENT_TAG_REGEXP, "");
}
var STRIP_COMMENT_TAG_REGEXP = /<!--[\s\S]*?-->/g;

/**
 * remove invisible characters
 *
 * @param {String} html
 * @return {String}
 */
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function(char) {
    var c = char.charCodeAt(0);
    if (c === 127) return false;
    if (c <= 31) {
      if (c === 10 || c === 13) return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}

exports.whiteList = getDefaultWhiteList();
exports.getDefaultWhiteList = getDefaultWhiteList;
exports.onTag = onTag;
exports.onIgnoreTag = onIgnoreTag;
exports.onTagAttr = onTagAttr;
exports.onIgnoreTagAttr = onIgnoreTagAttr;
exports.safeAttrValue = safeAttrValue;
exports.escapeHtml = escapeHtml;
exports.escapeQuote = escapeQuote;
exports.unescapeQuote = unescapeQuote;
exports.escapeHtmlEntities = escapeHtmlEntities;
exports.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
exports.clearNonPrintableCharacter = clearNonPrintableCharacter;
exports.friendlyAttrValue = friendlyAttrValue;
exports.escapeAttrValue = escapeAttrValue;
exports.onIgnoreTagStripAll = onIgnoreTagStripAll;
exports.StripTagBody = StripTagBody;
exports.stripCommentTag = stripCommentTag;
exports.stripBlankChar = stripBlankChar;
exports.cssFilter = defaultCSSFilter;
exports.getDefaultCSSWhiteList = getDefaultCSSWhiteList;


/***/ }),

/***/ "sfau":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wLXD":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_wLXD__;

/***/ })

/******/ });
});


// WEBPACK FOOTER //
// index.92912b9d2f07379c8ee7.js